import antdData from "antd/lib/locale/id_ID";

const messages = {
  "loader.preparing_workspace": "Menyiapkan ruang kerja Anda",
  "loader.preparing_workspace_desc":
    "Mohon tunggu sebentar, kami sedang memuat data perusahaan Anda.",

  "topBar.issuesHistory": "Issues History",
  "topBar.projectManagement": "Project Management",
  "topBar.typeToSearch": "Ketik untuk mencari...",
  "topBar.buyNow": "Beli Sekarang $24",
  "topBar.bitcoin": "Bitcoin",
  "topBar.profileMenu.hello": "Halo",
  "topBar.profileMenu.billingPlan": "Billing Plan",
  "topBar.profileMenu.role": "Role",
  "topBar.profileMenu.email": "Email",
  "topBar.profileMenu.phone": "Telp",
  "topBar.profileMenu.editProfile": "Ubah Profil",
  "topBar.profileMenu.logout": "Keluar",
  "topBar.billing.plan": "Paket",
  "topBar.billing.forever": "Selamanya",
  "topBar.billing.active_until": "Aktif s/d",
  "topBar.streamChat.switchLabel": "Stream chat",
  "topBar.streamChat.tooltip":
    "Saat Stream chat aktif, percakapan baru yang masuk ke Assigned akan otomatis membuka tab Assigned dan memfokuskan chat tersebut, sehingga Anda tidak perlu memeriksa satu per satu secara manual.",
  "topBar.serverUpdateNotice.close": "Tutup pemberitahuan",

  "notification.a_new_version_is_available": "Versi terbaru tersedia!",
  "notification.please_wait_prepare_to_reload_page":
    "Silakan tunggu, sistem akan melakukan pemasangan update dalam {{countDown}} detik. {{errorAutoReloadMessage}}",
  "notification.autoreload_failed": "Pemasangan otomatis gagal.",
  "notification.reload_immediately": "Pasangkan langsung",
  "notification.login_expired": "Sesi login Anda sudah berakhir!",
  "notification.login_google_failure": "Login dengan google gagal!",
  "notification.gajihub_is_now_on_google_play":
    "Gajihub kini tersedia di Google Play",
  "notification.gajihub_is_now_on_app_store":
    "Gajihub kini tersedia di App Store",
  "notification.install_now": "Install Sekarang",
  "notification.later": "Nanti Saja",

  "tooltip.hidden": "Sembunyikan",

  "validation.min": "Min {{value}}",
  "validation.max": "Maks {{value}}",
  "validation.max_characters": "Maks {{value}} karakter",

  "button.save": "Simpan",
  "button.save_add_new": "Simpan & Tambah Baru",
  "button.cancel": "Batal",
  "button.add": "Tambah",
  "button.duplicate": "Duplikat",
  "button.import": "Import",
  "button.export": "Ekspor",
  "button.print": "Print",
  "button.filter": "Filter",
  "button.clear_filter": "Hapus Filter",
  "button.delete": "Hapus",
  "button.edit": "Ubah",
  "button.next": "Selanjutnya",
  "button.back": "Kembali",
  "button.approve": "Setujui",
  "button.reject": "Tolak",
  "button.yes": "Ya",
  "button.no": "Tidak",
  "button.download": "Download",
  "button.confirmation": "Konfirmasi",
  "button.activate": "Aktifkan",
  "button.non_activate": "Non Aktifkan",
  "button.detail": "Detil",
  "button.add_line": "Tambah Baris",
  "button.select_all": "Pilih Semua",
  "button.deselect_all": "Hapus Semua",
  "button.schedule_now": "Jadwalkan Sekarang",
  "button.hello_can_i_help": "Halo, ada yang bisa saya bantu?",
  "button.close": "Tutup",
  "button.slide_to_confirm": "Geser untuk konfirmasi",
  "button.confirmed": "Dikonfirmasi!",
  "button.click_here": "Klik di sini",
  "button.upgrade": "Upgrade",
  "button.renew": "Perpanjang",
  "button.copy_to_clipboard": "Salin Link ke Clipboard",
  "button.archive": "Arsip",
  "button.unarchive": "Batalkan Arsip",
  "button.copy_link": "Salin Link",
  "button.upload": "Upload",
  "button.send": "Kirim",
  "button.search": "Cari",
  "button.reset": "Reset",

  "message.cannot_update_data": "Data tidak dapat diubah.",
  "message.cannot_return_data": "Data tidak dapat di kembalikan.",
  "message.link_has_been_copied": "Link berhasil disalin.",
  "message.on": "di",

  "popconfirm.title.delete": "Apakah Anda yakin untuk menghapus?",
  "popconfirm.title.archive": "Apakah Anda yakin untuk mengarsipkan?",
  "popconfirm.title.unarchive": "Apakah Anda yakin untuk batalkan arsip?",
  "popconfirm.title.reset": "Apakah Anda yakin untuk mengatur ulang?",

  "input.search": "Cari",
  "input.other": "Lainnya",
  "input.all": "Semua",
  "input.select_year": "Pilih tahun",
  "input.select_month": "Pilih bulan",
  "input.cannot_be_empty": "Tidak boleh kosong",

  "date.today": "Hari Ini",
  "date.yesterday": "Kemarin",
  "date.week": "Minggu",
  "date.this_week": "Minggu Ini",
  "date.last_week": "Minggu Lalu",
  "date.this_month": "Bulan Ini",
  "date.last_month": "Bulan Lalu",
  "date.last_7_days": "7 Hari Lalu",
  "date.last_30_days": "30 Hari Lalu",
  "date.this_year": "Tahun Ini",
  "date.last_year": "Tahun Lalu",
  "date.daily": "Harian",
  "date.monthly": "Bulanan",
  "date.weekly": "Mingguan",
  "date.yearly": "Tahunan",
  "date.year": "Tahun",
  "date.month": "Bulan",
  "date.day": "Hari",
  "date.days": "Hari",
  "date.date": "Tanggal",
  "date.hour": "Jam",
  "date.hours": "Jam",
  "date.minute": "Menit",
  "date.minutes": "Menit",
  "date.time": "Waktu",
  "date.date_range": "Rentang Tanggal",

  "nps.how_likely_you_recommend":
    "Seberapa besar kemungkinan Anda akan merekomendasikan Gajihub kepada teman atau rekan kerja?",
  "nps.not_likely": "Sama sekali tidak mungkin",
  "nps.very_likely": "Sangat mungkin",
  "nps.please_mention_another":
    "Mohon sebutkan hal lain yang ingin Anda sampaikan melalui kotak komentar di bawah",
  "nps.cannot_hide_nps": "Tidak dapat menutup NPS",
  "nps.cannot_send_nps": "Tidak dapat mengirim NPS",
  "nps.thank_you_your_input":
    "Terima kasih, masukan Anda sangat berarti. Kami mempelajari setiap masukan yang masuk.",

  "users.remember_me": "Ingat saya",
  "users.forgot_password_": "lupa password?",
  "users.welcome_to2": "Selamat datang di ",
  "users.login": "Masuk",
  "users.login_with_google": "Sign in dengan Google",
  "users.login_failed": "Login Gagal",
  "users.please_log_in": "Silakan masuk",
  "users.you_have_logged_out_automatically":
    "Anda sudah terlogout secara otomatis, silakan login kembali untuk melanjutkan.",
  "users.email_is_required": "Email harus diisi",
  "users.email_is_not_a_valid_email": "Email bukan email yang valid",
  "users.email": "Email",
  "users.password": "Password",
  "users.please_input_your_password": "Silakan masukkan password Anda",
  "users.please_input_your_email_address": "Silakan masukkan alamat email Anda",
  "users.hello": "Halo",
  "users.please_select_company_to_proceed":
    "silakan pilih perusahaan untuk melanjutkan",
  "users.leave_page": "Pindah halaman?",
  "users.changes_that_you_made_may_not_be_saved":
    "Perubahan yang anda buat mungkin tidak disimpan.",
  "users.registration_completed": "Pendaftaran berhasil!",
  "users.password_has_been_sent_to_email_sms":
    "Password telah dikirim ke email dan sms mu, silakan cek ya",
  users: "Pengguna",
  "users.name": "Nama Lengkap",
  "users.roles": "Peran",
  "users.search_by_name_or_email": "Cari berdasarkan nama atau email",
  "users.search_by_name": "Cari berdasarkan nama",
  "users.pending_invitation": "(Undangan tertunda)",
  "users.add_user": "Tambah pengguna",
  "users.delete_user": "Hapus pengguna",
  "users.edit_user": "Ubah Pengguna",
  "users.please_input_the_email_address": "Silakan masukkan alamat email.",
  "users.max_100_characters": "Maks 100 karakter.",
  "users.invalid_email_address_format": "Format alamat email tidak valid.",
  "users.please_select_a_role": "Silakan pilih peran.",
  "users.select_roles": "Pilih peran",
  "users.information": "Informasi",
  "users.information_invitation_email":
    "Email sudah dikirim ke {{email}}. Silakan minta kolega Anda untuk membuka email dan mengikuti instruksi berikutnya untuk mengaktifkan akun. Jika email tidak diterima, silakan cek folder bulk dan folder spam.",
  "users.only_displays_users_other_than_you":
    "Hanya menampilkan pengguna selain Anda",
  "users.please_select_a_user": "Silakan pilih pengguna.",
  "users.select_user": "Pilih pengguna",
  "users.select_user_to_delete": "Pilih Pengguna untuk Dihapus",
  "users.two_passwords_that_you_enter_is_inconsistent_":
    "Dua password yang Anda masukkan tidak konsisten.",
  "users.register_now": "Daftar sekarang",
  "users.restore_password": "Pulihkan Password",
  "users.enter_the_email_address_associated_with_your_account_and_well_email_you_a_link_to_reset_your_password":
    "Masukkan alamat email yang dikaitkan dengan akun Anda, dan kami akan mengirimi Anda email tautan untuk mereset password Anda ",
  "users.back_to_login": "Kembali untuk Login",
  "users.send_reset_link": "Kirim Reset Link",
  "users.please_check_your_email_inbox_and_follow_the_instruction_to_reset_your_password_if_email_hasnt_received_please_check_the_bulk_and_spam_folder":
    "Silakan periksa kotak masuk email Anda dan ikuti instruksi untuk mereset password Anda. Jika email belum diterima, silakan periksa folder bulk dan spam",
  "users.reset_password": "Setel Ulang Password",
  "users.request_new_password_reset": "Minta reset password lagi",
  "users.new_password": "password baru",
  "users.invalid_password_reset_token": "Token tidak valid",
  "users.your_password_reset_token_is_invalid_please_check_it_again_and_reload_the_page":
    "Token atur ulang password Anda tidak valid, periksa lagi dan muat ulang halaman",
  "users.confirm_new_password": "Konfirmasi password baru",
  "users.please_input_confirm_new_password":
    "Silakan masukkan Konfirmasi password baru",
  "users.please_input_new_password": "Silakan masukkan Password Baru",
  "users.status": "Status",
  "users.add_as_employee": "Tambah Sebagai Karyawan",
  "users.employee": "Karyawan",
  "users.email_is_not_registered_with_gajihub":
    "Email tidak terdaftar di GajiHub.",
  "users.please_fill_the_register_form": "Silakan isi formulir pendaftaran",
  "users.invalid_invitation_token": "Token undangan tidak valid",
  "users.your_invitation_token_is_invalid_please_check_it_again_and_reload_the_page":
    "Silakan periksa lagi dan muat ulang halaman",
  "users.you_are_invited_to_join": "Anda diundang untuk bergabung di",
  "users.do_you_agree_to_join": "Apakah Anda bersedia bergabung di",
  "users.please_input_your_name": "Silakan masukkan name.",
  "users.phone_number": "Nomor telepon",
  "users.phone_number_is_required": "Nomor Telepon harus diisi",
  "users.no_phone_number_worng": "Nomor telepon salah",
  "users.phone_number_must_be_at_least_5_characters":
    "Nomor Telepon minimal 5 karakter",
  "users.phone_number_cannot_be_longer_than_20_characters":
    "Nomor Telepon tidak boleh lebih dari 20 karakter",
  "users.please_input_your_phone": "Silakan masukkan no ponsel Anda",
  "users.activate": "Mengaktifkan",
  "users.waiting_for_confirmation": "Menunggu Konfirmasi",
  "users.resending_help":
    "Untuk mengkonfirmasi, silakan buka inbox email, dan klik link yang dikirim oleh CRM.id.",
  "users.resending": "Kirim Ulang",
  "users.success_resending": "Sukses Mengirim Undangan",
  "users.success_resending_desc":
    "Undangan berhasil dikirim ulang ke email {{email}}. Silakan buka inbox email Anda, dan klik link yang telah dikirm oleh Kledo.",
  "users.you_have_registered_on_gajiHub_with_your_username":
    "Kamu sudah terdaftar di GajiHub dengan username",
  "users.click_the_button_below_to_log_in_to_gajiHub":
    "Klik tombol dibawah untuk login ke GajiHub",
  "users.info_is_only_has_role_employee":
    "Anda login sebagai karyawan.<br/> Untuk melanjutkan menggunakan aplikasi gajihub silakan pilih opsi berikut:",
  "users.login_to_the_ess_application": "Login di Aplikasi ESS",

  please_input_the_name: "Silakan masukkan nama!",
  please_input_the_message: "Silakan masukkan pesan!",
  max_characters: "Maksimal {{value}} karakter.",
  min_characters: "Minimal {{value}} karakter",
  only_number_allowed: "Hanya angka yang diperbolehkan",
  no_data: "Data tidak ditemukan",
  select_contact: "Pilih kontak",
  send_wa_messages: "Kirim Pesan Whatsapp",
  the_conversation_has_been_successfully_closed: "Chat berhasil ditutup",
  the_conversation_has_been_successfully_updated:
    "Detil percakapan berhasil diubah",
  no_chat_yet: "Belum ada chat",
  please_start_chatting_first: "Silahkan mulai chat terlebih dahulu",
  start_chat: "Mulai chat baru",
  no_conversation_selected_yet: "Belum ada chat yang dipilih",
  please_select_conversation_first: "Silahkan pilih chat terlebih dahulu",
  please_select_contact: "Silahkan pilih kontak",
  please_select_template: "Silahkan pilih template",
  to: "Tujuan",
  message: "Pesan",
  contact: "Kontak",
  number: "Nomor",
  select_template: "Pilih template",
  message_content: "Isi pesan",
  agent: "Agen",
  select_agent: "Pilih agen",
  phone_number: "Nomor handphone",
  select_phone_number: "Pilih nomor handphone",
  update_contact_success: "Kontak berhasil diubah",
  update_contact_error: "Kontak gagal diubah",
  change_contact: "Ubah Kontak",
  company_name: "Nama perusahaan",
  contact_name: "Nama kontak",
  contact_info: "Informasi Kontak",
  please_input_the_number: "Silahkan masukkan nomor HP",
  please_input_message: "Silahkan masukkan pesan",

  "companies.company_list": "Daftar Perusahaan",
  "companies.add_company": "Tambah Perusahaan",
  "companies.created_on": "Dibuat",
  "companies.as": "Sebagai",
  "companies.are_you_sure_to_delete_this_company":
    "Apakah Anda yakin untuk menghapus perusahaan ini?\nSetelah dihapus, data tidak dapat dikembalikan",

  "profile.title": "Profilku",
  profile: "Profil",
  "profile.image_profile": "Gambar Profil",
  "profile.my_profile": "Profilku",
  "profile.old_password": "Password lama",
  "profile.please_input_the_old_password": "Silakan masukkan password lama.",
  "profile.new_password": "Password baru",
  "profile.please_input_the_new_password": "Silakan masukkan password baru.",
  "profile.max_100_characters": "Maks 100 karakter.",
  "profile.confirm_new_password": "Ulangi password baru",
  "profile.please_input_the_confirm_new_password":
    "Silakan masukkan password baru yang dikonfirmasi! ",
  "profile.email_or_username": "Email",
  "profile.please_input_the_email/username": "Silakan masukkan email.",
  "profile.the_input_is_not_valid-e-mail": "Silakan masukkan email yang valid",
  "profile.full_name": "Nama lengkap",
  "profile.please_input_the_full_name": "Silakan masukkan nama lengkap.",
  "profile.only_alphanumeric_allowed": "Hanya alfanumerik yang diizinkan.",
  "profile.phone_number": "Nomor telepon",
  "profile.please_input_the_phone_number": "Silakan masukkan nomor telepon.",
  "profile.max_20_characters": "Maks 20 karakter.",
  "profile.only_number_allowed": "Hanya angka yang diizinkan.",
  "profile.user_profile_successfully_updated": "Profil berhasil diperbarui.",
  "profile.error_cannot_update_user_profile": "Gagal memperbarui profil.",
  "profile.user_password_successfully_updated": "Password berhasil diperbarui.",
  "profile.error_cannot_update_user_password": "Gagal memperbarui password.",
  "profile.change_password": "Ganti password",
  "profile.two_passwords_that_you_enter_is_inconsistent_":
    "Dua password yang Anda masukkan tidak konsisten.",
  "profile.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit":
    "Password setidaknya 8 karakter, setidaknya 1 huruf besar dan setidaknya 1 digit.",
  "profile.password_atleast_6_characters": "Password setidaknya 6 karakter.",
  "profile.logout_from_all_device": "Logout dari semua perangkat",
  "profile.cannot_logout_from_all_device":
    "Tidak dapat logout dari semua perangkat",

  "error.an_error_happened": "Terjadi Sebuah Error",
  "error.failed_to_load_data_from_server": "Gagal mengambil data dari server!",
  "error.failed_to_delete_data_from_server":
    "Gagal menghapus data dari server!",
  "error.failed_save_data_to_server": "Gagal menyimpan data ke server!",
  "error.max_characters": "Maksimal {{value}} karakter.",
  "error.min_characters": "Minimal {{value}} karakter.",
  please_fill_one_of_filter_first:
    "Silahkan isi salah satu filter terlebih dahulu",

  "property.company": "Perusahaan",
  "property.company_details": "Data Perusahaan",
  "property.company_name": "Nama",
  "property.email_address": "Alamat email",
  "property.please_input_the_company_name": "Silakan masukkan company name.",
  "property.max_100_characters": "Maks 100 karakter.",
  "property.only_alphanumeric_allowed": "Hanya alfanumerik yang diizinkan.",
  "property.invalid_email_address_format": "Format alamat email tidak valid.",
  "property.phone_number": "Nomor telepon",
  "property.max_20_characters": "Nomor telepon",
  "property.only_number_allowed": "Hanya angka yang diizinkan.",
  "property.address": "Alamat Penagihan",
  "property.address_delivery": "Alamat Pengiriman",
  "property.country": "Negara",
  "property.tax_number": "Nomor NPWP Perusahaan",
  "property.please_select_the_country": "Silakan pilih negara.",
  "property.select_country": "Pilih negara",
  "property.company_logo": "Logo Perusahaan",

  "property.file_uploaded_successfully": "berkas berhasil diunggah.",
  "property.file_upload_failed": "gagal unggah file.",
  "property.you_can_only_upload_jpg_or_png_file_":
    "Anda hanya dapat mengunggah file JPG / PNG.",
  "property.image_must_smaller_than": "Gambar harus lebih kecil dari",
  "property.image_width_must_smaller_than":
    "Lebar gambar harus lebih kecil dari",
  "property.image_height_must_smaller_than":
    "Tinggi gambar harus lebih kecil dari ",
  "property.click_or_drag_file_to_this_area_to_upload":
    "Klik atau seret file ke area ini untuk mengunggah",
  "property.image_file_size_maximal": "Ukuran file gambar maksimal",
  "property.image_file_dimension_maximal": "Dimensi file gambar maksimal",
  "property.preview": "Pratinjau",
  settings: "Pengaturan",
  "settings.company": "Data dan logo perusahaan",
  "settings.users": "Undang staff dan kolegamu menggunakan CRM.id",
  "settings.roles": "Atur hak akses pengguna",
  "settings.profile": "Atur profil dan ubah password",
  "settings.billing": "Upgrade dan perpanjangan paket",
  "settings.business_flow": "Atur alur bisnismu",
  "settings.template": "Atur template kirim pesan",
  "settings.apps": "Koneksikan Apps mu dengan API CRM.id",
  "settings.audit": "Pantau log perubahan data",
  "settings.category": "Atur kategori percakapan anda",
  company: "Perusahaan",
  billing: "Billing",
  businessflow: "Alur Bisnis",
  template: "Template",
  tag: "Tag",
  select_tag: "Pilih tag",
  add_tag: "Tambah tag",
  email: "Email",
  tag_name: "Nama tag",
  name: "Nama",
  change_tag: "Ubah Tag",
  create_success: "Berhasil menambahkan {{value}}.",
  create_failed: "Gagal menambahkan {{value}}.",
  update_success: "Berhasil merubah {{value}}.",
  update_failed: "Gagal merubah {{value}}.",
  delete_success: "Berhasil menghapus {{value}}.",
  delete_failed: "Gagal menghapus {{value}}.",
  select_color: "Pilih warna",
  contact_not_found: "Kontak tidak ditemukan",

  a_new_version_is_available: "Versi app baru tersedia",
  reload_will_refresh_the_app_you_may_lose_the_progress_if_any:
    "Reload akan melakukan refresh aplikasi, Anda mungkin akan kehilangan progress pekerjaan yang ada.",
  cancel_will_install_the_update_next_time_you_visit_the_app:
    "Cancel akan menginstall update ketika Anda berkunjung kembali ke aplikasi.",
  file_uploaded_successfully: "Berkas file {{value}} berhasil diunggah.",
  file_upload_failed: "Berkas file {{value}} gagal diunggah.",

  "billing.title": "Billing",
  "billing.upgrade_title": "Upgrade Billing",
  "billing.balance": "Sisa saldo",
  "billing.topup_balance": "Top Up Saldo",
  "billing.current_month": "Bulan ini",
  "billing.last_month": "Bulan lalu",
  "billing.current_year": "Tahun ini",
  "billing.last_year": "Tahun lalu",
  "billing.total": "Total",
  "billing.usage": "Penggunaan",
  "billing.topup": "Top up",
  "billing.number_of_chats": "Jumlah chat",
  "billing.payment_history": "Riwayat Pembayaran",
  "billing.date": "Tanggal",
  "billing.description": "Deskripsi",
  "billing.transaction": "Transaksi",
  "billing.payment_confirmation": "Konfirmasi Pembayaran",
  "billing.for_balance_topup": "Untuk top up saldo, silahkan transfer ke nomor",
  "billing.bank_account_number": "rekening berikut",
  "billing.after_transfer": "Setelah melakukan transfer, silakan konfirmasi",
  "billing.wa": "ke WA",
  template_select_type: "Pilih Tipe",
  template_select_status: "Pilih Status",
  template_select_show: "Pilih Tampil",
  template_all: "Semua {{value}}",
  template_marketing: "Pemasaran",
  template_utility: "Utilitas",
  template_authentication: "Otentikasi",
  template_approved: "Disetujui",
  template_pending: "Tertunda",
  template_rejected: "Ditolak",
  template_show: "Tampil",
  template_hide: "Sembunyi",
  template_name: "Nama",
  template_type: "Tipe",
  template_status: "Status",
  template_update_success: "Template berhasil diperbarui.",
  template_update_error: "Template gagal diperbarui.",
  template_create_success: "Template berhasil ditambahkan.",
  template_create_error: "Template gagal ditambahkan.",
  template_category: "Kategori",
  template_sub_category:
    "Pilih kategori yang paling menggambarkan template pesan Anda",
  template_sub_name: "Beri nama template pesan Anda",
  template_please_input: "Nama tidak boleh kosong",
  template_please_input_content: "Konten tidak boleh kosong",
  template_content_placeholder: "Ketik template pesan WhatsApp Anda di sini...",
  template_characters: "Karakter:",
  template_add_variable: "Tambahkan Variabel",
  template_add_variable_empty: "Tambah Variabel Kosong",
  template_preview: "Pratinjau Template",
  template_variable_name: "Nama Variable",
  template_example: "Contoh: Utility Template",
  template_content: "Konten",
  template_marketing_sub:
    "Promosi atau informasi tentang bisnis, produk, atau layanan Anda.",
  template_utility_sub:
    "Pesan tentang transaksi, akun, order, atau permintaan pelanggan tertentu.",
  template_authentication_sub:
    "Password sekali pakai atau OTP yang digunakan untuk mengautentikasi transaksi atau login.",
  template_add_button: "Tambah Template",
  template_show_success: "Template berhasil ditampilkan.",
  template_hide_success: "Template berhasil disembunyikan.",
  template_show_error: "Template gagal ditampilkan.",
  template_hide_error: "Template gagal disembunyikan.",
  template_move_success: "Template berhasil dipindahkan.",
  template_move_error: "Template gagal dipindahan.",

  roles: "Peran",
  add_role: "Tambah Peran",
  edit_role: "Ubah Peran",
  "roles.search_by_role_name": "Cari berdasarkan nama peran",
  "approvals.and_number_others": "dan {{value}} lainnya",
  user: "Pengguna",
  "settings.set_users": "Atur Pengguna",
  "roles.select_role_to_delete": "Pilih Peran untuk Dihapus",
  "roles.please_select_a_role": "Silakan pilih peran.",
  "roles.select_role": "Pilih peran",
  "roles.successfully_deleted": "Berhasil dihapus.",
  "roles.error_cannot_delete": "Gagal menghapus",
  "roles.name": "Nama peran",
  "roles.successfully_added": "Berhasil ditambahkan.",
  "roles.error_cannot_add": "Tidak bisa menambahkan",
  "roles.users_with_this_role": "Pengguna dengan peran ini",
  "roles.click_here_to_set_users":
    "<t>Klik disini</t> untuk mengatur pengguna.",
  roles_successfully_updated: "Peran berhasil diperbarui.",
  "roles.error_cannot_update_role": "Gagal memperbarui peran.",
  roles_moved_successfully: "Peran berhasil dipindahkan.",
  "roles.error_cannot_move_the_channel": "Gagal memindahkan channel.",
  "priceRule.active": "Aktif",
  "settings.set_roles": "Atur Peran",
  "users.error_cannot_delete": "Gagal menghapus",
  "users.error_cannot_add": "Tidak bisa menambahkan",
  "users.error_cannot_update": "Tidak bisa memperbarui",
  "users.role": "Peran di perusahaan sebagai",
  "users.click_here_to_set_roles": "<t>Klik disini</t> untuk mengatur peran.",
  "users.error_cannot_update_user": "Gagal memperbarui pengguna.",
  roles_not_found: "Peran dengan id {{id}} tidak ditemukan",

  tags: "Tag",
  tag_contact: "Kontak",
  create_tag_success: "Tag berhasil dibuat",
  create_tag_failed: "Tag gagal dibuat",
  update_tag_success: "Tag berhasil diperbarui",
  update_tag_failed: "Tag gagal diperbarui",
  delete_tag_success: "Tag berhasil dihapus",
  delete_tag_failed: "Tag gagal diperbarui",
  "settings.tags": "Atur tag penanda kontak",

  "settings.channel": "Atur channel Anda",
  archive: "Arsipkan",
  please_input_name: "Silahkan masukkan nama",
  add_channel_message:
    "Halo Tim Hebat CRM.id, saya {{name}} dari {{companyName}} mau tambah channel, mohon dibantu!",
  change_status_pending_channel:
    "Silahkan hubungi {{phoneNumber}} untuk mengaktifkan channel",
  "appSetting.apps": "Aplikasi",
  "appSetting.date_created": "Tanggal Dibuat",
  "appSetting.app_name": "Nama Aplikasi",
  "appSetting.client_id": "Client ID",
  "appSetting.client_id_has_been_copied": "Client ID berhasil disalin",
  "appSetting.secret_has_been_copied": "Secret berhasil disalin",
  "appSetting.endpoint_has_been_copied": "API Endpoint URL berhasil disalin",
  "appSetting.documentation_has_been_copied":
    "Dokumentasi API berhasil disalin",
  "appSetting.api_documentation_endpoint": "Dokumentasi API Endpoint",
  "appSetting.please_input_name": "Silakan masukkan nama aplikasi",
  "appSetting.please_redirect_uri": "Silakan masukkan redirect URI",
  "appSetting.please_valid_uri": "Silakan masukkan URL yang valid",
  "appSetting.error_cannot_get": "Tidak dapat mengambil data aplikasi",
  "appSetting.error_cannot_create": "Tidak dapat membuat aplikasi",
  "appSetting.error_cannot_edit": "Tidak dapat mengubah aplikasi",
  "appSetting.error_cannot_delete": "Tidak dapat menghapus aplikasi",
  "appSetting.app_has_been_created_make_sure_save_secret":
    "Aplikasi baru berhasil dibuat, silakan pastikan simpan kode secret di bawah sebelum berpindah ke halaman lain.",
  "appSetting.secret_code_just_shown_once":
    "Kode secret hanya tampil sekali. Simpan kode ini, karena setelah ini Anda tidak dapat melihat kode secret ini lagi.",
  "appSetting.integrate_your_app_with_crm":
    "Integrasikan aplikasimu dengan CRM.id",
  "appSetting.now_app_can_be_integrated_with_crm":
    "Sekarang aplikasi, website, maupun software-mu bisa diintegrasikan dengan CRM.id.",
  "appSetting.for_more_details_lets_see_the_video":
    "Untuk lebih jelasnya, yuk lihat videonya",
  "appSetting.watch_video": "Lihat video",
  "breadcrumb.detail": "Detil",
  "table.lets_create_your_first_x": "Yuk mulai buat {{name}} pertamamu!",
  "table.data_empty": "Data Kosong",
  "table.data_x_empty": "Data {{name}} Kosong",
  "title.add_tag": "Tambah Tag",
  add_apps: "Tambah Aplikasi",
  detail_apps: "Detil Aplikasi",

  "settings.categories": "Atur kategori percakapan Anda",
  "title.categories": "Kategori",
  "button.addCategories": "Tambah Kategori",
  confirm_delete_category: "Apakah Anda yakin untuk menghapus kategori ini?",
  delete_category: "Kategori berhasil dihapus.",
  delete_category_failed: "Tidak dapat menghapus kategori.",
  create_category: "Kategori berhasil dibuat.",
  create_category_failed: "Tidak dapat membuat kategori.",
  update_category: "Kategori berhasil diubah.",
  update_category_failed: "Tidak dapat mengubah kategori.",
  add_category: "Tambah Kategori",
  sub_category: "Sub Kategori dari",
  select_category: "Pilih Kategori",
  archive_category: "Kategori berhasil diarsipkan.",
  archive_category_failed: "Tidak dapat mengarsipkan kategori.",
  unarchive_category: "Pengarsipan kategori berhasil dibatalkan.",
  unarchive_category_failed: "Tidak dapat membatalkan pengarsipan kategori.",
  move_category: "Kategori berhasil dipindahkan.",
  move_category_failed: "Tidak dapat memindahkan kategori.",
  move_category_invalid: "Posisi kategori tidak valid.",
  categories: "Kategori",

  menu_setting_company: "Perusahaan",
  menu_setting_billing: "Billing",
  menu_setting_businessflow: "Alur Bisnis",
  menu_setting_setting_template: "Template",
  menu_setting_profile: "Profil",
  menu_setting_users: "Pengguna",
  menu_setting_roles: "Peran",
  menu_setting_tags: "Tags",
  menu_setting_channel: "Channel",
  menu_setting_apps: "Open API",
  menu_setting_categories: "Kategori",
  total_contact: "Total Kontak",
  new_contacts_today: "Kontak Baru Hari Ini",
  new_contacts_7_days: "Kontak Baru 7 Hari",
  new_contacts_30_days: "Kontak Baru 30 Hari",

  group: "Grup",
  edit_group: "Ubah Grup",
  add_group: "Tambah Grup",
  add_contact: "Tambah Kontak",
  edit_contact: "Ubah Kontak",
  update_contact_group_success: "Kontak group berhasil diperbarui.",
  update_contact_group_failed: "Tidak dapat mengubah grup kontak.",
  create_contact_group_success: "Kontak grup berhasil dibuat.",
  create_contact_group_failed: "Tidak dapat menambah grup kontak.",
  please_input_the_unit_name: "Silakan masukkan nama satuan.",
  only_alphanumeric_allowed: "Hanya huruf dan angka yang diperkenankan.",

  //contact
  show_photo: "Tampilkan Foto",
  hide_photo: "Sembunyikan Foto",
  photo: "Foto",
  contact_information: "Informasi Kontak",
  contact_type: "Tipe Kontak",
  please_select_a_contact_type_with_minimal:
    "Silakan pilih tipe kontak, minimal 1 tipe kontak.",
  please_select_a_group: "Silakan pilih grup.",
  select_contact_type: "Pilih tipe kontak",
  input_contact_name: "Silakan masukkan nama kontak.",
  salutation: "Sapaan",
  select_salutation: "Pilih sapaan",
  phone: "Telepon",
  input_phone: "Silakan masukkan no telepon.",
  input_company: "Silakan masukkan nama perusahaan.",
  fill_company_first: "Lengkapi nama perusahaan terlebih dahulu.",
  "contact_validation.name_warning_1":
    "Pastikan nama pelanggan merupakan nama sebenarnya.",
  "contact_validation.name_warning_2":
    "Nama pelanggan akan digunakan dalam pengiriman reminder otomatis via WhatsApp.",
  "contact_validation.name_invalid_chars":
    "Nama hanya boleh berisi huruf, spasi, titik, dan tanda petik (').",
  "contact_validation.name_no_salutation":
    "Nama tidak boleh diawali sapaan/singkatan (mis. Ibu, Bapak, Pak, Bu, Kak, Sdr).",
  "contact_validation.name_not_all_lowercase":
    "Nama tidak boleh semua huruf kecil.",
  "contact_validation.name_not_all_uppercase":
    "Nama tidak boleh semua huruf besar.",
  "contact_validation.company_invalid_chars":
    "Nama perusahaan hanya boleh berisi huruf, angka, spasi, dan . - / | &.",
  "contact_validation.company_not_all_lowercase":
    "Nama perusahaan tidak boleh semua huruf kecil.",
  "contact_validation.company_not_all_uppercase":
    "Nama perusahaan tidak boleh semua huruf besar.",
  "contact_validation.company_same_as_name":
    "Nama perusahaan tidak boleh sama dengan nama.",
  "contact_validation.company_warning":
    "Pastikan nama perusahaan benar dan sesuai.",
  "contact_validation.must_contain_letter":
    "Harus mengandung minimal satu huruf.",
  billing_address: "Alamat Penagihan",
  country: "Negara",
  province: "Provinsi",
  city: "Kota",
  select_country: "Silakan pilih Negara.",
  select_province: "Silakan pilih Provinsi.",
  select_city: "Silakan pilih Kota.",
  date_of_birth: "Tanggal Lahir",
  contact_created: "Kontak berhasil dibuat.",
  contact_created_failed: "Tidak dapat menambah kontak.",
  delete_photo_failed: "Tidak dapat menghapus foto.",
  contact_deleted: "Kontak berhasil dihapus.",
  contact_deleted_failed: "Tidak dapat menghapus kontak.",
  contact_archive: "Kontak berhasil diarsipkan.",
  contact_archive_failed: "Tidak dapat mengarsipkan kontak.",
  contact_unarchive: "Pengarsipan kontak berhasil dibatalkan.",
  contact_unarchive_failed: "Tidak dapat membatalkan pengarsipkan kontak.",
  confirm_delete_contact: "Apakah Anda yakin untuk menghapus kontak ini?",
  confirm_archive_contact: "Apakah Anda yakin untuk mengarsipkan kontak ini?",
  confirm_unarchive_contact:
    "Apakah Anda yakin untuk membatalkan pengarsipan kontak ini?",
  contact_edited: "Kontak berhasil diubah.",
  contact_edited_failed: "Tidak dapat mengubah kontak.",
  button_prev: "Sebelumnya",
  button_next: "Selanjutnya",
  tooltip_prev_calendar: "Kalender sebelumnya",
  tooltip_next_calendar: "Kalender selanjutnya",
  contact_edit: "Ubah Kontak",
  contact_detail: "Detil Kontak",
  table_show_data: "Tampilkan Data",
  all: "Semua",
  vendor: "Vendor",
  employee: "Pegawai",
  customer: "Pelanggan",
  other: "Lainnya",
  all_group: "Semua Grup",
  without_archive: "Tanpa arsip",
  with_archive: "Dengan arsip",
  only_archive: "Arsip Saja",
  show_archive: "Tampilkan Arsip",
  min_show_one_column: "Minimal tampil satu kolom",
  mass_delete_info:
    "**Kontak  yang telah mempunyai history chat tidak dapat dihapus, hanya bisa diarsipkan.",
  mass_delete: "Hapus Kontak Massal",
  can_be_deleted: "Bisa dihapus",
  archived: "Diarsipkan",
  massDelete_are_you_sure:
    "Apakah Anda yakin akan menghapus/mengarsipkan {{value}} Kontak?",
  data_irreversible: "Data yang dihapus tidak dapat dikembalikan.",
  massDelete_progress: "{{count}} data dari total {{total}} telah terhapus",
  massDelete_success: "Total {{count}} data telah berhasil dihapus",
  rows_selected: "baris dipilih",
  contact_per_group: "KONTAK PER GRUP",
  contact_per_province: "KONTAK PER PROVINSI",
  new_contact: "KONTAK BARU",
  contact_total: "TOTAL KONTAK",
  contact_group_deleted: "Kontak grup berhasil dihapus.",
  contact_group_deleted_failed: "Tidak dapat menghapus grup kontak.",
  remove_group: "Hapus Grup",
  announce_contact_group_delete:
    "Catatan: Hanya grup yang belum mempunyai kontak yang dapat dihapus.",
  select_contact_group: "Silakan pilih Grup Kontak",
  conversations: "Percakapan",
  "chat-lines-count": "Jumlah Baris Chat",
  the_latest_chat: "Chat Terkini",
  the_first_chat: "Chat Pertama",
  contacts: "Kontak",
  send_chat: "Kirim Pesan",
  history_conversation: "Riwayat Percakapan",
  "users.welcome_to_crm": "SELAMAT DATANG DI CRM.id ",
  "users.phone": "Telepon",
  "users.yes": "Ya",
  "users.no": "Tidak",
  "users.only_number_allowed": "Hanya angka yang diizinkan.",
  "profile.password_atleast_8_characters": "Password setidaknya 8 karakter.",
  "profile.password_pattern_minimum_1_capital_and_1_lowercase_letter":
    "Minimal 1 huruf kapital dan 1 huruf kecil.",
  "profile.password_pattern_minimum_1_number": "Minimal 1 angka.",

  "option.update_success": "Opsi berhasil diperbarui",
  "option.update_failed": "Tidak dapat memperbarui opsi",
  "option.conversation": "Percakapan",
  "option.category": "Kategori",
  "option.category_subtitle":
    "Percakapan wajib menyertakan kategori sebelum ditutup.",
  "option.notes": "Catatan",
  "option.notes_subtitle":
    "Percakapan wajib menyertakan catatan sebelum ditutup.",

  "label.close_conversation": "Tutup Percakapan",
  "label.detail_conversation": "Detil",
  "title.detail_conversation": "Detil Percakapan",
  "title.save_conversation": "Simpan",
  "title.close_conversation":
    "Silakan lengkapi data berikut sebelum menutup percakapan :",
  "required.category": "Silakan pilih kategori.",
  "title.notes": "Catatan",
  "placeholder.notes": "Silakan masukan catatan",

  "roles.please_input_the_role_name": "Silakan masukkan nama peran.",
  "roles.max_100_characters": "Maks 100 karakter.",
  "bots.chat_bot": "Chat Bot",
  "bots.chat_bot_flows": "Alur Chat Bot",
  "bots.manage": "Kelola",

  "blast-message": "Pesan Massal",
  "blast_message.column_name": "Nama",
  "blast_message.column_number_recipients": "Jumlah Penerima",
  "blast_message.column_sent": "Terkirim",
  "blast_message.column_read": "Dibaca",
  "blast_message.column_replied": "Dibalas",
  "blast_message.column_date": "Tanggal",
  "blast_message.column_failed": "Gagal",
  "blast_message.column_not_sent_yet": "Belum dikirim",
  "blast_message.column_delivered": "Tersampaikan",

  "blast_message.btn.add_contact": "Tambah Kontak",
  "blast_message.btn.add_template": "Tambah Template",
  "blast_message.btn.import_contact": "Impor Kontak",

  "blast_message.text_add_contact_first":
    "Sebelum dapat mengirimkan blast, silakan menambahkan daftar kontak terlebih dahulu.",
  "blast_message.text_add_template_first":
    "Sebelum dapat mengirimkan blast, silakan membuat template pesan terlebih dahulu.",

  blast_message_create: "Kirim Pesan Massal",
  "blast_message_create.message_template_cannot_be_empty":
    "Template Body harus diisi",

  "blast_message_create.tooltip_name":
    "Nama tidak dapat dilihat oleh penerima, hanya dapat diterima oleh anda dan tim.",
  "blast_message_create.label_phone_number": "Nomor Telepon",
  "blast_message_create.label_recipient": "Penerima",
  "blast_message_create.label_all_contacts": "Semua Kontak",
  "blast_message_create.label_contact_type": "Tipe Kontak",
  "blast_message_create.label_contact_group": "Grup Kontak",
  "blast_message_create.label_per_contact": "Per Kontak",
  "blast_message_create.label_contact_types":
    "Pilih tipe kontak yang akan dikirimi pesan",
  "blast_message_create.label_contact_groups":
    "Pilih grup kontak yang akan dikirimi pesan",
  "blast_message_create.label_contacts":
    "Pilih kontak yang akan dikirimi pesan",
  "blast_message_create.label_total_recipient": "Total Penerima",
  "blast_message_create.label_message_template": "Template Pesan",

  "blast_message_create.required_name": "Nama harus diisi",
  "blast_message_create.required_contact_types": "Tipe kontak harus dipilih",
  "blast_message_create.required_contact_groups": "Grup kontak harus dipilih",
  "blast_message_create.required_contacts": "Kontak harus dipilih",
  "blast_message_create.required_message_template": "Silakan pilih template",

  "blast_message_create.message_successfully_created":
    "Pesan Massal berhasil dibuat",
  "blast_message_create.btn_send_now": "Kirim Sekarang",
  "blast_message_create.label_recipient_list": "Daftar Kontak Penerima",
  "blast_message_create.title_confirmation":
    "Apakah anda yakin untuk mengirimkan pesan ini ke {{value}} kontak ?",
  "blast_message_create.btn_yes_send_now": "Ya, Kirim Sekarang",
  "blast_message_create.subtitle_confirmation":
    "Pengiriman pesan massal ini tidak dapat dibatalkan. Akan dikenakan biaya per jumlah penerima pesanan",
  type: "Tipe",
  new: "Baru",
  blast_message_detail: "Detil Pesan Massal",
  "blast_message_detail.send_time": "Waktu Kirim",
  "blast_message_detail.message_delivery_status": "Status Pengiriman Pesan",
  "settings.bots":
    "Atur chat bots untuk percakapan yang lancar dan sesuai preferensi",
  "bots.select_channels": "Pilih Channel",
  "bots.please_select_channels": "Silahkan pilih channel",
  "bots.please_input_response": "Silahkan masukkan response",
  "bots.keywords": "Kata Kunci",
  "bots.press_enter_to_add_keyword": "Tekan Enter menambahkan keyword",
  "bots.please_add_keyword": "Silahkan tambahkan kata kunci",
  "bots.new": "Baru",
  "bots.reuse": "Gunakan kembali",
  "bots.please_select_user_input": "Silahkan pilih user input",
  "bots.channels": "Channel",
  "bots.are_you_sure_want_to_publish": "Apakah Anda yakin untuk publish?",
  "bots.are_you_sure_want_to_unpublish": "Apakah Anda yakin untuk unpublish?",

  "settings.divisions": "Atur divisi Anda",

  "division.delete_success": "Divisi berhasil dihapus",
  "division.delete_failed": "Tidak dapat menghapus divisi",
  "division.update_success": "Divisi berhasil diubah",
  "division.update_failed": "Tidak dapat mengubah divisi",
  "division.create_success": "Divisi berhasil dibuat",
  "division.create_failed": "Tidak dapat membuat divisi",

  "division.add": "Tambah Divisi",
  "division.who_spv": "Siapakah supervisor pada divisi ini?",
  "division.select_spv": "Silakan pilih supervisor",
  "division.who_agents": "Siapa saja yang menjadi agen pada divisi ini?",
  "division.select_agents": "Silakan pilih agen",
  "division.access_channel": "Divisi ini dapat mengakses ke channel mana saja?",
  "division.select_channel": "Silakan pilih channel",

  "assign.switch_agent": "Alihkan Agen",
  "assign.select_transfer_agent": "Pilih agen untuk dialihkan",
  "assign.select_transfer_agent_validate": "Silakan pilih agen",
  "assign.select_transfer_agent_placeholder": "Pilih agen",
  "assign.transfer_conversation": "Alihkan Percakapan",
  "assign.take_conversation_for_me": "Ambil percakapan untuk saya",
  "assign.take_conversation_failed":
    "Gagal mengambil percakapan, silakan coba lagi.",

  "agent.name_agent": "Nama Agen",
  "agent.max_conversation": "Maks Percakapan",
  "agent.duplicate_warning": "Anda tidak bisa memilih agen yang sudah ada",
  "agent.success_create_agent_limit": "Agen limit chat berhasil dibuat",
  "agent.failed_create_agent_limit": "Agen limit chat gagal dibuat",
  "agent.success_remove_agent_limit": "Agen limit berhasil dihapus",
  "agent.failed_remove_agent_limit": "Agen limit gagal dihapus",

  "option.assign_mode": "Mode Assign Agen",
  "option.assign_mode_desc": "Apakah fitur mode assign agen diaktifkan?",
  "option.agents_can_take_over_conversations":
    "Agen dapat mangambil alih percakapan yang belum di-assign",
  "option.agents_can_take_over_conversations_desc":
    "Aktifkan opsi ini untuk mengizinkan agen mengambil alih percakapan yang belum ditetapkan ke agen tertentu",
  "option.agents_transfer_conversations":
    "Agen dapat mengalihkan percakapan ke agen yang lain",
  "option.agents_transfer_conversations_desc":
    "Aktifkan opsi ini untuk memungkinkan agen mentransfer percakapan ke agen lain",
  "option.agents_automatic_assign": "Percakapan otomatis di-assign ke agen",
  "option.agents_automatic_assign_desc":
    "Aktifkan opsi ini untuk secara otomatis menetapkan percakapan masuk ke agen yang tersedia",
  "option.agents_limit_conversation": "Batasi percakapan yang dihandle agen",
  "option.agents_limit_conversation_desc":
    "Aktifkan opsi ini untuk membatasi jumlah percakapan aktif yang dapat ditangani setiap agen secara bersamaan",
  "option.maximum_conversation_agent":
    "Tetapkan Jumlah Percakapan Maksimum per Agen",
  "option.maximum_conversation_agent_desc":
    "Tentukan jumlah maksimum percakapan aktif yang dapat ditangani agen pada saat yang sama",
  "option.maximum_conversation_per_agent":
    "Batasi jumlah percakapan masing-masing agen",
  "option.maximum_conversation_per_agent_desc":
    "Tetapkan batasan jumlah percakapan aktif yang dapat ditangani setiap agen untuk memastikan manajemen beban kerja yang efektif",
  "option.transfer_conversation_unanswered":
    "Transfer Otomatis Percakapan yang Tidak Terjawab",
  "option.transfer_conversation_unanswered_desc":
    "Secara otomatis mentransfer percakapan ke agen lain jika percakapan tersebut tidak terjawab selama beberapa menit tertentu",
  "option.transfer_conversation_unanswered_time":
    "Atur Waktu Transfer untuk Percakapan yang Tidak Terjawab",
  "option.transfer_conversation_unanswered_time_desc":
    "Tentukan jumlah menit setelah percakapan yang tidak terjawab akan secara otomatis ditransfer ke agen lain",
  "option.notify_spv_if_unanswered":
    "Beritahu Supervisor jika Percakapan Tidak Dijawab",
  "option.notify_spv_if_unanswered_desc":
    "Aktifkan opsi ini untuk mengirim pemberitahuan kepada supervisor jika percakapan tidak dijawab selama beberapa menit tertentu",
  "option.set_time_notify_spv_if_unanswered":
    "Atur Waktu untuk Memberitahu Supervisor tentang Percakapan yang Tidak Terjawab",
  "option.set_time_notify_spv_if_unanswered_desc":
    "Tentukan jumlah menit setelah pemberitahuan akan dikirim ke supervisor jika percakapan tetap tidak terjawab",

  "lead-and-task-management": "Lead & Task Management",
  "task.task_type": "Tipe Task",
  "task.task_stages": "Tahapan Task",
  "task.task_status": "Status Task",
  "task.company": "Perusahaan",
  "task.plan": "Paket",
  "task.stage": "Tahapan",
  "task.status": "Status",
  "task.deadline": "Batas Waktu",
  "task.report": "Laporan",
  "task.action": "Aksi",
  "task.send": "Kirim",
  "task.send_and_complete": "Kirim & Selesaikan",
  "task.completed": "Selesaikan",
  "task.stop": "Hentikan",
  "task.assignAt": "Ditugaskan pada",
  "task.maxResponseAt": "Maksimal Balasan pada",
  "task.release": "Rilis",
  "task.startResponse": "Mulai Balasan",
  "task.completedAt": "Selesai pada",
  "task.createdAt": "Dibuat pada",
  "task.detail": "Detil",
  "task.stop_reason": "Alasan",

  "task.admin.all": "Semua Admin",
  "task.stages.all": "Semua Tahapan",
  "task.status.all": "Semua Status",

  "task.filter_title_task_type": "Tipe Task",
  "task.filter_title_admin": "Admin",
  "task.filter_title_stage": "Tahapan Task",
  "task.filter_title_status": "Status Task",

  "task.success_send_wa": "Pesan berhasil dikirim",
  "task.failed_send_wa": "Pesan tidak dapat dikirim",

  "task.required_select_phone_number": "Silakan pilih nomor telepon",
  "task.select_phone_number": "Pilih nomor telepon",

  "task.noHP": "No HP",
  "task.noHP.placeholder": "Masukkan nomor HP",
  "task.required_noHP": "Silakan masukkan nomor HP",

  "task.success_set_complete": "Task berhasil diselesaikan",
  "task.failed_set_complete": "Task tidak dapat diselesaikan",

  "task.required_report": "Silakan masukkan laporan",
  "task.required_report.placeholder": "Masukkan laporan . . .",

  "task.success_set_stop": "Task berhasil dihentikan",
  "task.failed_set_stop": "Task tidak dapat dihentikan",

  "task.required_reason": "Silakan pilih alasan",
  "task.required_reason.placeholder": "Pilih alasan",

  "permission.tasks": "Task",
  "permission.task_list": "Daftar Task",
  "permission.task_list_other": "Daftar Task Milik Admin Lain",
  "permission.setting_chatbots": "Chat Bots",

  "division.select_division": "Pilih divisi agen",
  "division.select_division_required": "Silakan pilih divisi agen",
  "division.select_placeholder": "Divisi agen",

  "division.edit": "Ubah Divisi",
  "division.can_receive_messages": "Apakah divisi ini dapat menerima pesan?",
  "division.can_receive_messages_title": "Menerima Pesan",
  "division.title_priority": "Divisi Prioritas",

  "division.success_create": "Divisi Prioritas berhasil dibuat",
  "division.failed_create": "Tidak dapat membuat Divisi Prioritas",
  "division.add_division_title": "Tambah Divisi Prioritas",
  "division.name": "Nama Divisi",
  "division.success_remove": "Divisi Prioritas berhasil dihapus",
  "division.failed_remove": "Tidak dapat menghapus Divisi Prioritas",
  "division.success_update": "Divisi Prioritas berhasil diubah",
  "division.failed_update": "Tidak dapat mengubah Divisi Prioritas",

  reports: "Laporan",
  "online-duration": "Durasi Online",
  "team-response-time": "Waktu Respon Tim",
  "individual-response-time": "Waktu Respon Individu",
  "auto-transfer-conversation": "Percakapan Transfer Otomatis",
  "reports.channel": "Channel",
  "reports.channel_all": "Semua Channel",
  divisions: "Divisi",
  "reports.division_all": "Semua Divisi",
  "reports.agent": "Agen",
  "reports.agent_all": "Semua Agen",
  "reports.sender": "Pengirim",
  "reports.sender_all": "Semua Pengirim",
  "reports.customer": "Pelanggan",

  "reports.daily": "Harian",
  "reports.hourly": "Per Jam",
  "reports.monthly": "Bulanan",
  "reports.hour": "Jam",
  "reports.minute": "Menit",
  "reports.seconds": "Detik",
  "reports.times": "Kali",

  "link.show_more": "Tampilkan Selengkapnya",
  "link.show_less": "Sembunyikan",

  "individual-response-time_detail": "Detil Waktu Respon Individu",
  "reports.detail_message": "Detil Pesan",
  "reports.detail_response_time": "Waktu Respons",
  "reports.total_user": "Total Pengguna",
  "reports.total_conversation": "Total Percakapan",
  "reports.total_auto_transfer": "Total Dialihkan Sistem",
  "reports.average_response_time": "Rata-rata Response Time",
  "businessflow.agent_auto_offline": "Agen Otomatis Offline",
  "businessflow.agent_auto_offline_desc":
    "Aktifkan mode ini untuk secara otomatis mengubah status agen menjadi offline setelah waktu tertentu",
  "businessflow.wa_last_active_to_auto_offline":
    "Atur Batas Waktu Tidak Aktif untuk Auto Offline",
  "businessflow.wa_last_active_to_auto_offline_desc":
    "Atur batas waktu tidak aktif dalam menit sebelum status agen diubah menjadi offline secara otomatis",
  "businessflow.activity": "Aktivitas",

  "faqs.whats_your_question": "Apa Pertanyaan Anda?",
  "faqs.most_popular": "Terpopuler",
  "faqs.most_help": "Paling Membantu",
  "faqs.search_result": 'Hasil Pencarian "{{value}}"',
  "faqs.title_by_category": 'Berdasarkan Kategori "{{value}}"',
  "faqs.title_by_tag": 'Berdasarkan Tag "{{value}}"',
  "faqs.was_this_answer_helpful": "Apakah jawaban ini membantu?",
  "faqs.last_update": "Update Terakhir",
  "faqs.copy_raw_text": "FAQ berhasil disalin",
  "faqs.category": "Kategori",
  faqs: "FAQ",
  "faqs.detail": "Detil FAQ",
  "property.file_size_maximal": "Ukuran file maksimal",
  "property.file_maximal": "File yang diupload maksimal {{value}}",
  load_more_messages: "Tampilkan Pesan Lama",
  "detail_response_time.redirect": "Alihan",

  meeting_schedule: "Jadwal Meeting",
  meeting_management: "Manajemen Meeting",
  "meeting-schedule": "Jadwal Meeting",
  "meeting-management": "Manajemen Meeting",
  "settings.meeting_schedule": "Sesuaikan pengaturan penjadwalan meeting",

  "meeting_schedule.workday": "Hari Kerja",
  "meeting_schedule.dayoff": "Hari Libur",
  "meeting_schedule.user": "Pengguna",
  "meeting_schedule.user_schedule": "Pengguna Jadwal",
  "meeting_schedule.user_schedule_desc":
    "Tentukan siapa saja admin yang dapat mempunyai jadwal",
  "meeting_schedule.group_admin": "Grup Admin",
  "meeting_schedule.admin_add": "Tambah Admin",
  "meeting_schedule.admin_edit": "Ubah Admin",
  "meeting_schedule.cannot_select_past_time_slots":
    "Tidak dapat memilih waktu yang sudah lewat",

  "meeting_schedule.success_add_admin": "Admin berhasil ditambahkan",
  "meeting_schedule.success_edit_admin": "Admin berhasil diubah",
  "meeting_schedule.success_delete_admin": "Admin berhasil dihapus",

  "meeting_schedule.select_admin": "Pilih Admin",
  "meeting_schedule.select_admin_required": "Admin wajib diisi",
  "meeting_schedule.select_group": "Pilih Grup",
  "meeting_schedule.select_group_required": "Grup admin wajib diisi",

  "meeting_schedule.group_admin_add": "Tambah Grup Admin",
  "meeting_schedule.group_admin_edit": "Ubah Grup Admin",
  "meeting_schedule.group_channel": "Channel",

  "meeting_schedule.success_add_admin_group": "Grup Admin berhasil ditambahkan",
  "meeting_schedule.success_edit_admin_group": "Grup Admin berhasil diubah",
  "meeting_schedule.success_delete_admin_group": "Grup Admin berhasil dihapus",

  "meeting_schedule.input_name": "cth., Tim Marketing",
  "meeting_schedule.input_color": "Warna",
  "meeting_schedule.name_required": "Nama wajib diisi",
  "meeting_schedule.color_required": "Warna wajib diisi",
  "meeting_schedule.auto_select_admin": "Otomatis Pilih Admin",

  "meeting_schedule.data_add": "Data berhasil disimpan",
  "meeting_schedule.workday_title": "Atur Hari dan Jam kerja Seluruh Tim",
  "meeting_schedule.workday_description":
    "Tentukan hari kerja dan jam kerja seluruh tim",

  "meeting_schedule.from_required": "Dari wajib diisi",
  "meeting_schedule.to_required": "Sampai wajib diisi",
  "meeting_schedule.both_required": "Dari dan Sampai wajib diisi",
  "meeting_schedule.time_invalid": "Waktu tidak valid",
  "meeting_schedule.time_overlap":
    "Waktu Tumpang Tindih dengan waktu yang sudah ada",
  "meeting_schedule.from": "Dari",
  "meeting_schedule.to": "Sampai",
  "meeting_schedule.add_field": "Tambah Kolom",

  "meeting_schedule.dayoff_success_delete": "Hari Libur berhasil dihapus",
  "meeting_schedule.dayoff_description":
    "Tentukan hari libur yang akan diterapkan ke semua admin",
  "meeting_schedule.add_dayoff": "Tambah Hari Libur",

  "meeting_schedule.dayoff_success_add": "Hari Libur berhasil ditambahkan",
  "meeting_schedule.dayoff_date_required": "Tanggal wajib diisi",
  "meeting_schedule.dayoff_name_required": "Nama wajib diisi",
  "meeting_schedule.dayoff_name_placeholder": "cth., Libur Tahun Baru",

  "meeting_management.calendar": "Kalender",
  "meeting_management.daily": "Harian",
  "meeting_management.tooltip_prev_month": "Bulan sebelumnya",
  "meeting_management.tooltip_next_month": "Bulan selanjutnya",
  "meeting_management.timeline_no_group_for_admin":
    "Admin ini belum memiliki grup admin yang dipakai untuk membuat jadwal.",
  "meeting_management.all_schedule": "Semua Jadwal",
  "meeting_management.no_schedule": "Tidak ada jadwal yang dapat ditampilkan",
  "meeting_management.no_schedule_hint":
    "Tambahkan agen ke jadwal terlebih dahulu.",
  "meeting_management.add_agent": "Tambah Agen",
  "meeting_management.created_by": "Dibuat Oleh",
  "meeting_management.search_placeholder":
    "Cari nama agen, kontak, perusahaan...",
  "meeting_management.export_xls": "Export XLS",
  "meeting_management.schedule_meeting": "Jadwalkan Meeting",
  "meeting_management.contact_schedule_list": "Jadwal Meeting",
  "meeting_management.no_schedule_yet": "Belum ada jadwal meeting",
  "meeting_management.status": "Status",
  "meeting_management.all_statuses": "Semua Status",
  "meeting_management.last_template_messages": "Riwayat Pesan Template",
  "meeting_management.no_template_messages": "Belum ada pesan template.",
  "meeting_management.setting_workday": "Atur Hari Kerja",
  "meeting_management.add_schedule": "Tambah Jadwal",

  "meeting_management.admin": "Admin",
  "meeting_management.all_admins": "Semua Admin",
  "meeting_management.all_groups": "Semua Grup",
  "meeting_management.success_delete_schedule": "Jadwal berhasil dihapus",
  "meeting_management.description": "Keterangan",
  "meeting_management.meeting_report": "Hasil Meeting",
  "meeting_management.tags": "Tag",
  "meeting_management.add_tags": "Pilih atau tambah tag",
  "meeting_management.all_tags": "Semua Tag",
  "meeting_management.tags_update_failed": "Gagal memperbarui tag",
  "meeting_management.note_updated": "Keterangan berhasil diperbarui",
  "meeting_management.note_update_failed":
    "Keterangan gagal diperbarui. Silakan coba lagi.",
  "meeting_management.title_delete_schedule": "Hapus Jadwal",
  "meeting_management.title_delete_schedule_desc":
    "Apakah kamu yakin untuk hapus jadwal?",
  "meeting_management.edit_schedule": "Ubah Jadwal",
  "meeting_management.set_unavailable": "Setel Tidak Tersedia",
  "meeting_management.set_unavailable_desc":
    "Apakah kamu yakin untuk setel tidak tersedia untuk {{value}}?",
  "meeting_management.set_available": "Setel Tersedia",
  "meeting_management.set_available_desc":
    "Apakah kamu yakin untuk setel tersedia untuk {{value}}?",
  "meeting_management.at": "Pukul",
  "meeting_management.schedule": "Jadwal",
  "meeting_management.schedule_note": "Catatan",
  "meeting_management.schedule_status": "Status",
  "meeting_management.schedule_slot_available": "Tersedia",
  "meeting_management.schedule_slot_unavailable": "Tidak tersedia",
  "meeting_management.note_empty_hint": "Klik untuk menambah catatan",
  "meeting_management.status_updated": "Status berhasil diperbarui",
  "meeting_management.status_update_failed":
    "Status gagal diperbarui. Silakan coba lagi.",
  "meeting_management.send_reminder": "Kirim Reminder",
  "meeting_management.reminder_sent": "Reminder terkirim",
  "meeting_management.reminder_send_failed": "Gagal mengirim reminder",
  "meeting_management.reminder_no_zoom_templates":
    'Tidak ada template dengan judul mengandung "zoom" untuk nomor WhatsApp ini',
  "meeting_management.reminder_missing_phone_number":
    "Nomor WhatsApp untuk jadwal tidak tersedia di data detail",
  "meeting_management.reminder_from_channel": "Dari: {{channel}}",
  "meeting_management.reminder_column": "Reminder",
  "meeting_management.reminder_button": "Reminder",
  "meeting_management.last_modified_by":
    "Terakhir diubah oleh {{name}} pada {{time}}",
  "meeting_management.view_reminders": "Lihat reminder",
  "meeting_management.reminder_list_title": "Daftar Reminder",
  "meeting_management.reminder_message": "Pesan",
  "meeting_management.reminder_send_time": "Waktu Kirim",
  "meeting_management.reminder_status": "Status",
  "meeting_management.reminder_load_failed": "Gagal memuat daftar reminder.",
  "meeting_management.reminder_morning_skipped":
    "Reminder pagi hari di hari H tidak dikirimkan karena meeting dijadwalkan sebelum jam 11 pagi.",
  "meeting_management.change_log": "Riwayat Perubahan",
  "meeting_management.reminder_detail_load_error":
    "Gagal memuat detail jadwal. Tutup dan coba lagi.",
  "meeting_management.detil": "Detil",
  "meeting_management.calendar_tooltip_no_booking":
    "Waktu ini tersedia dan belum ada pemesanan.",

  "audit.by": "oleh",
  "audit.title": "Audit",

  "meeting_schedule.select_admin_placeholder": "Pilih Admin",
  "meeting_schedule.admin_no_group": "Tanpa grup",
  "meeting_schedule.not_available": "Tidak tersedia",

  "meeting_reminder.title": "Pengingat Meeting",
  "meeting_reminder.with": "dengan",
  "meeting_reminder.countdown_suffix": "lagi",
  "meeting_reminder.soon": "Sebentar lagi",
  "meeting_reminder.now": "Sedang berlangsung",
  "meeting_reminder.hour": "jam",
  "meeting_reminder.minute": "menit",
  "meeting_reminder.second": "detik",
  "meeting_finished.title": "Meeting Selesai",
  "meeting_finished.intro": "Meeting berikut telah selesai",
  "meeting_finished.intro_sub":
    "Mohon perbarui status & hasil meeting di bawah ini.",
  "meeting_finished.status_question": "Bagaimana status meetingnya?",
  "meeting_finished.status_placeholder": "Pilih status",
  "meeting_finished.report_question": "Apa hasil dari meeting tadi?",
  "meeting_finished.report_placeholder": "Tuliskan hasil meeting...",
  "meeting_finished.report_min": "Minimal {{min}} karakter",
  "meeting_finished.save": "Simpan",
  "meeting_finished.reschedule": "Reschedule",
  "meeting_finished.saved": "Status meeting berhasil disimpan",
  "meeting_finished.save_failed": "Gagal menyimpan status meeting",
  "meeting_finished.load_failed": "Gagal memuat detail meeting",
  "meeting_finished.send_report_to_adminhebat": "Kirim laporan ke AdminHebat",
  "meeting_finished.select_app": "Pilih aplikasi",
  "meeting_finished.select_company": "Pilih perusahaan",
  "meeting_finished.company_other": "Lainnya",
  "meeting_finished.loading_recommendations": "Memuat rekomendasi...",
  "meeting_finished.type_to_search": "Ketik untuk mencari perusahaan...",
  "meeting_finished.back_to_recommendations": "← Kembali ke rekomendasi",
  "meeting_finished.select_company_required":
    "Pilih perusahaan terlebih dahulu untuk mengirim laporan.",

  "meeting_report_wa.modal_title": "Kirim Ringkasan ke Customer",
  "meeting_report_wa.title": "Pratinjau pesan WhatsApp",
  "meeting_report_wa.desc":
    "Poin hasil meeting yang akan dikirim ke customer. Klik teks untuk mengedit.",
  "meeting_report_wa.drafting": "Menyusun ringkasan...",
  "meeting_report_wa.draft_failed": "Gagal membuat draft, coba lagi.",
  "meeting_report_wa.retry": "Coba lagi",
  "meeting_report_wa.edit_point_hint": "Klik untuk mengisi poin...",
  "meeting_report_wa.point_aria": "Poin ke-{{number}}",
  "meeting_report_wa.points_label": "Poin hasil diskusi",
  "meeting_report_wa.points_limit":
    'Tersedia {{max}} poin. Poin yang dikosongkan dikirim sebagai "-".',
  "meeting_report_wa.length_counter": "{{length}} / {{max}} karakter",
  "meeting_report_wa.too_long": "Pesan terlalu panjang, ringkas poinnya.",
  "meeting_report_wa.greeting_disclaimer":
    "Sapaan menyesuaikan waktu saat pesan dikirim.",
  "meeting_report_wa.send": "Kirim ke customer",
  "meeting_report_wa.sent":
    "Ringkasan sedang dikirim ke customer via WhatsApp.",
  "meeting_report_wa.send_failed": "Gagal mengirim ringkasan ke customer.",

  "meeting_schedule.select_group_placeholder": "Pilih Grup Admin",

  "meeting_schedule.title_first_step":
    "Anda ingin menjadwalkan meeting untuk group apa?",
  "meeting_schedule.auto_assign_admin": "Admin otomatis",
  "meeting_schedule.admin_no_group_message":
    "Agent ini tidak mempunyai grup, silakan ubah agen ini supaya mempunyai grup",
  "meeting_schedule.title_second_step": "Pilih admin yang dijadwalkan!",
  "meeting_schedule.previous": "Kembali",
  "meeting_schedule.next": "Selanjutnya",
  "meeting_schedule.back": "Kembali",
  "meeting_schedule.auto": "Auto",
  "meeting_schedule.auto_desc": "Sistem memilihkan agent otomatis",
  "meeting_schedule.when_question": "Kapan meeting dijadwalkan?",
  "meeting_schedule.pick_time": "Pukul berapa?",
  "meeting_schedule.today": "Hari Ini",
  "meeting_schedule.tomorrow": "Besok",
  "meeting_schedule.day2": "Besok Lusa",
  "meeting_schedule.day3": "3 Hari Lagi",
  "meeting_schedule.pick_date": "Pilih tanggal",
  "meeting_schedule.in_15_min": "15 menit lagi",
  "meeting_schedule.hour_label": "Jam {{hour}}",
  "meeting_schedule.other_time": "Jam lain",
  "meeting_schedule.duration_question": "Berapa lama durasi meeting?",
  "meeting_schedule.dur_1h": "1 jam",
  "meeting_schedule.dur_minutes": "{{m}} menit",
  "meeting_schedule.other_duration": "Lainnya",
  "meeting_schedule.hours": "jam",
  "meeting_schedule.minutes": "menit",
  "meeting_schedule.auto_slots_full":
    "Semua slot jadwal untuk tanggal {{date}} jam {{time}} telah full, silakan pilih waktu terdekat:",
  "meeting_schedule.auto_no_slots": "Tidak ada slot tersedia.",
  "meeting_schedule.no_agent_available":
    "Tidak ada agent tersedia untuk slot ini.",
  "meeting_schedule.auto_check_failed": "Gagal memeriksa ketersediaan.",
  "meeting_schedule.auto_agent_selected":
    "Sistem otomatis memilih <bold>{{name}}</bold> untuk meeting ini.",
  "meeting_schedule.auto_view_reason": "Lihat alasan",
  "meeting_schedule.auto_reason_title": "Alasan pemilihan agent",
  "meeting_schedule.auto_reason_desc":
    "Agent dipilih berdasarkan defisit tertinggi (kuota − aktual) di antara yang tersedia pada slot ini, dihitung berdasar jumlah jam kerja 30 hari terakhir.",
  "meeting_schedule.auto_picked": "dipilih",
  "meeting_schedule.auto_col_agent": "Agent",
  "meeting_schedule.agent_col_date": "Tanggal",
  "meeting_schedule.agent_schedules_title": "Jadwal {{name}}",
  "meeting_schedule.wa_preview_title": "Pratinjau pesan WhatsApp",
  "meeting_schedule.wa_preview_desc":
    "Pesan ini otomatis dikirim ke pelanggan saat jadwal dibuat.",
  "meeting_schedule.notif_created": "Meeting Dijadwalkan",
  "meeting_schedule.notif_rescheduled": "Jadwal Meeting Diubah",
  "meeting_schedule.notif_contact_changed": "Kontak Meeting Diubah",
  "meeting_schedule.notif_status_changed": "Status Meeting Diubah",
  "meeting_schedule.notif_status_new": "Meeting Dijadwalkan",
  "meeting_schedule.notif_status_confirmed": "Meeting Dikonfirmasi",
  "meeting_schedule.notif_status_done": "Meeting Terlaksana",
  "meeting_schedule.notif_status_cancelled": "Meeting Dibatalkan",
  "meeting_schedule.notif_status_no_show": "Meeting Tidak Hadir",
  "meeting_schedule.notif_status_zoom": "Penawaran Zoom",
  "meeting_schedule.notif_status_attend": "Konfirmasi Hadir",
  "meeting_schedule.notif_report_updated": "Laporan Meeting",
  "meeting_schedule.notif_deleted": "Meeting Dihapus",
  "meeting_schedule.notif_view": "Lihat",
  "meeting_schedule.agent_schedules_on_date_title":
    "Jadwal {{name}} — {{date}}",
  "meeting_schedule.agent_schedules_total": "Total: {{count}} jadwal",
  "meeting_schedule.auto_col_priority": "Prioritas",
  "meeting_schedule.auto_col_workhours": "Jam Kerja",
  "meeting_schedule.auto_workhours": "{{h}} Jam {{m}} menit",
  "meeting_schedule.auto_workhours_h": "{{h}} Jam",
  "meeting_schedule.auto_col_quota": "Kuota",
  "meeting_schedule.auto_col_actual": "Aktual",
  "meeting_schedule.auto_col_deficit": "Defisit",
  "meeting_schedule.auto_col_available": "Tersedia",
  "meeting_schedule.auto_legend_quota":
    "Target jumlah meeting untuk agent berdasarkan jam kerjanya dalam periode.",
  "meeting_schedule.auto_legend_actual":
    "Jumlah meeting yang sudah dijalani agent pada periode tersebut.",
  "meeting_schedule.auto_legend_deficit":
    "Kuota − Aktual. Makin besar berarti makin jauh di bawah target, sehingga lebih diprioritaskan.",
  "meeting_schedule.auto_legend_available":
    "Apakah agent kosong (tidak ada jadwal bentrok) pada slot waktu yang diminta.",
  "meeting_schedule.auto_total_meetings": "Total meeting",
  "meeting_schedule.auto_total_work": "Total jam kerja",
  "meeting_schedule.title_third_step":
    "Akan dijadwalkan dihari dan jam berapa?",
  "meeting_schedule.tab_third_step_calendar": "Kalender",
  "meeting_schedule.tab_third_step_custom": "Kustom",
  "meeting_schedule.no_hours":
    "Tidak ada jam yang tersedia, silakan pilih tanggal lain",
  "meeting_schedule.title_fourth_step": "Masukkan jadwal untuk tanggal",
  "meeting_schedule.at": "pukul",
  "meeting_schedule.description_placeholder": "Masukkan keterangan",
  "meeting_schedule.description_required": "Keterangan wajib diisi",

  "meeting_schedule.set_unavailable_desc1":
    "Apakah kamu mau setel tidak tersedia untuk admin {{value}} atau semua admin ?",
  "meeting_schedule.all_admins": "Semua Admin",
  "meeting_management.set_available_desc1":
    "Apakah kamu mau setel tersedia untuk admin {{value}} atau semua admin ?",

  "meeting_schedule.set_available_all_title": "Setel tersedia semua waktu",
  "meeting_schedule.set_unavailable_all_title":
    "Setel tidak tersedia semua waktu",

  "meeting_management.set_available_desc2":
    "Apakah kamu mau setel tersedia semua waktu untuk admin {{value}} atau semua admin?",
  "meeting_management.set_available_desc3":
    "Apakah kamu yakin untuk setel tersedia semua waktu untuk {{value}}?",

  "meeting_management.set_unavailable_desc2":
    "Apakah kamu mau setel tidak tersedia semua waktu untuk admin {{value}} atau semua admin?",
  "meeting_management.set_unavailable_desc3":
    "Apakah kamu yakin untuk setel tidak tersedia semua waktu untuk {{value}}?",
  "meeting_management.set_unavailable_modal_title":
    "Setel tidak tersedia untuk {{value}}",
  "meeting_management.set_unavailable_note_placeholder": "Masukkan catatan",
  "help.title": "Help",
  "help.title_detail": "Detil Help",

  "faqsUser.title": "FAQ",
  "faqsUser.category_name": "Nama Kategori",
  "faqsUser.category": "Kategori",
  "faqsUser.category_name_required": "Silakan masukkan nama kategori",
  "faqsUser.category_name_placeholder": "Masukkan nama kategori",
  "faqsUser.question": "Pertanyaan",
  "faqsUser.question_required": "Silakan masukkan pertanyaan",
  "faqsUser.question_placeholder": "Masukkan pertanyaan",
  "faqsUser.answer": "Jawaban",
  "faqsUser.answer_required": "Silakan masukkan jawaban",
  "faqsUser.answer_placeholder": "Masukkan jawaban",
  "faqsUser.add_tag_faq": "Tambah Tag FAQ",
  "faqsUser.labelsubcategory": "Buat Sub Kategori di bawah kategori {{value}}",
  "faqsUser.labelsubcategory_required": "Silakan masukkan Sub Kategori",
  "faqsUser.labelsubcategory_placeholder": "Masukkan Sub Kategori",
  "faqsUser.success_update_faq_category": "Kategori FAQ berhasil diubah",
  "faqsUser.error_update_faq_category": "Kategori FAQ tidak dapat diubah",
  "faqsUser.success_create_faq_category": "Kategori FAQ berhasil ditambahkan",
  "faqsUser.error_create_faq_category": "Kategori FAQ tidak dapat ditambahkan",
  "faqsUser.success_delete_faq_category": "Kategori FAQ berhasil dihapus",
  "faqsUser.error_delete_faq_category": "Kategori FAQ tidak dapat dihapus",

  "faqsUser.success_update_faq_user": "FAQ untuk pengguna berhasil diubah",
  "faqsUser.success_create_faq_user": "FAQ untuk pengguna berhasil ditambahkan",
  "faqsUser.success_delete_faq_user": "FAQ untuk pengguna berhasil dihapus",
  "faqsUser.error_update_faq_user": "FAQ untuk pengguna tidak dapat diubah",
  "faqsUser.error_create_faq_user":
    "FAQ untuk pengguna tidak dapat ditambahkan",
  "faqsUser.error_delete_faq_user": "FAQ untuk pengguna tidak dapat dihapus",
  "faqsUser.create_faq": "Buat FAQ pengguna",
  "faqsUser.update_faq": "Ubah FAQ pengguna",

  "faqsUser.success_update_faq_subcategory": "Sub Kategori FAQ berhasil diubah",
  "faqsUser.error_update_faq_subcategory":
    "Sub Kategori FAQ tidak dapat diubah",
  "faqsUser.success_create_faq_subcategory":
    "Sub Kategori FAQ berhasil ditambahkan",
  "faqsUser.error_create_faq_subcategory":
    "Sub Kategori FAQ tidak dapat ditambahkan",
  "faqsUser.success_delete_faq_subcategory":
    "Sub Kategori FAQ berhasil dihapus",
  "faqsUser.error_delete_faq_subcategory":
    "Sub Kategori FAQ tidak dapat dihapus",
  "faqsUser.create_sub_category": "Tambah Sub Kategori",
  "faqsUser.update_sub_category": "Ubah Sub Kategori",

  "faqsUser.create_category": "Tambah Kategori",
  "faqsUser.update_category": "Ubah Kategori",

  "faqsUser.success_create_tag_faq": "Tag FAQ berhasil ditambahkan",
  "faqsUser.error_create_tag_faq": "Tag FAQ tidak dapat ditambahkan",
  "faqsUser.add_tag_faq_user": "Tambah Tag FAQ untuk Pengguna",
  "faqsUser.required_tag_name": "Silakan masukkan nama tag",
  "faqsUser.placeholder_tag_name": "Masukkan nama tag",

  "faqsUser.select_tag_faq": "Pilih tag FAQ",
  "faqsUser.faq_title": "Judul FAQ",
  "faqsUser.faq_created_at": "Dibuat",
  "faqsUser.faq_updated_at": "Diperbarui",
  "faqsUser.faqUser_title_add": "Tambah FAQ",
  "faqsUser.faqUser_title_edit": "Ubah FAQ",

  "faqsUser.all_channel": "Semua Channel",
  "faqsUser.add_sub_category": "Tambah Sub Kategori",
  "faqsUser.edit": "Ubah",
  "faqsUser.load_more": "Muat Lebih Banyak",
  "faqsUser.please_select_sub_category":
    "Silakan pilih sub kategori untuk ditampilkan",

  "faqsUser.label_channel": "Channel",
  "faqsUser.label_channel_required": "Silakan pilih minimal 1 channel",
  add: "Tambah",
  edit: "Edit",
  delete: "Hapus",
  cancel: "Batal",
  save: "Simpan",
  close: "Tutup",
  channels: "Channel",
  apps: "API Key",
  detail: "Detil",
  create: "Tambah",

  "option.user_rating": "Rating Pengguna",
  "option.user_rating_subtitle":
    "Kirimkan pesan untuk meminta pengguna memberikan rating setiap percakapan diakhiri.",
  "statistics-user-ratings": "Statistik Rating Pengguna",
  "list-of-user-ratings": "Daftar Rating Pengguna",

  "userRating.average": "Rata-Rata Rating",
  "userRating.total": "Jumlah Rating",

  "reports.message": "Pesan",
  "reports.with_message_all": "Semua",
  "reports.with_message": "Dengan Pesan",
  "reports.without_message": "Tanpa Pesan",

  "reports.comment": "Komentar",
  "reports.all": "Semua",
  "reports.with_comment": "Dengan Komentar",
  "reports.without_comment": "Tanpa Komentar",

  "reports.rating": "Rating",
  "reports.rating_value_all": "Semua Rating",
  "report.show_chat": "Lihat Chat",
  "meeting_schedule.no_schedule_weekend":
    "Tidak ada jadwal yang tersedia untuk hari libur",
  "meeting_schedule.configure_workday":
    "Silakan atur hari kerja di menu pengaturan > jadwal meeting,",
  "meeting_schedule.click_here": "klik disini",
  "meeting_schedule.successfully_save_schedule": "Berhasil Simpan Jadwal",
  "meeting_schedule.successfully_edit_schedule": "Berhasil Ubah Jadwal",

  "permission.setting_meeting_schedule": "Jadwal Meeting",
  "permission.meeting_schedule": "Manajemen Meeting",
  "permission.meeting_schedule_calendar": "Kalender Meeting",
  "permission.meeting_schedule_all": "Semua Jadwal Meeting",
  "permission.meeting_schedule_other_admin_access":
    "Lihat Jadwal Milik Admin Lain",

  "meeting_schedule.available_time": "Waktu yang tersedia",
  "meeting_schedule.available_time_pick": "Pilih waktu yang tersedia",
  edit_category: "Ubah Kategori",

  tag_contact_success_edit: "Tag berhasil disimpan ke kontak",
  help: "Help",

  "faqsUser.searchResult": "Hasil Pencarian",
  bots: "Chat Bot",
  audit: "Audit",
  "meeting_schedule.success_unavailable_all":
    "Berhasil set unavailable disemua waktu",
  "meeting_schedule.success_available_all":
    "Berhasil set available disemua waktu",
  "meeting_schedule.success_unavailable": "Berhasil set unavailable",
  "meeting_schedule.success_available": "Berhasil set available",

  otp_verification: "Verifikasi Kode OTP",
  otp_info:
    "Kami mendeteksi Anda mencoba login dari device berbeda. Untuk keamanan, silakan masukkan kode OTP",
  otp_needHelp: "Mengalami kendala?",
  otp_contactUs: "Hubungi Kami",
  otp_success_resend: "Kode OTP telah dikirim ulang ke email {{value}}.",
  otp_required: "Kode OTP wajib diisi.",
  otp_length: "Kode OTP harus 6 karakter.",
  otp_send_email: "Kode OTP telah dikirimkan ke email",
  otp_recheck:
    "Periksa email dan masukkan kode tersebut untuk menyelesaikan login.",
  otp_button_verif: "Verifikasi",
  otp_button_cancel: "Batalkan",
  otp_not_received: "Belum menerima kode OTP?",
  otp_resend: "Kirim ulang kode",

  "chatbot.success_update_flow": "Node berhasil diperbarui",
  "chatbot.error_update_flow": "Node tidak dapat diperbarui",
  "chatbot.success_update": "Bot berhasil diperbarui",
  "chatbot.error_update": "Bot tidak dapat diperbarui",
  "chatbot.success_update_publish": "Status publish berhasil diperbarui",
  "chatbot.error_update_publish": "Status publish tidak dapat diperbarui",

  "help.placeholder_search": "Apa Pertanyaan Anda?",
  otp_verification_change_email: "Verifikasi Perubahan Email",
  otp_needHelp_email: "Butuh bantuan?",
  otp_verification_change_email_info:
    "Anda sedang mencoba mengganti alamat email login Anda menjadi:",
  otp_verification_change_email_description:
    "Demi keamanan akun Anda, kami telah mengirimkan kode OTP ke alamat email lama dan email baru Anda. Silakan masukkan kedua kode OTP di bawah ini untuk menyelesaikan proses perubahan email.",
  "quality-assurance": "Quality Assurance",
  "quality-assurance-menu": "Quality Assurance",
  "data-quality-assurance": "Data Quality Assurance",
  "statistics-quality-assurance": "Statistik Quality Assurance",
  "chat-volume-statistics": "Statistik Volume Chat Per Agent",
  "chat-volume-statistics-daily": "Statistik Volume Chat Harian",
  "reports.agent_num_char_count": "Volume",
  "reports.chat_statistics_line": "Line",

  "settings-quality-assurance": "Kategori Quality Assurance",
  title: "Judul",
  description: "Deskripsi",
  weight: "Bobot",

  "reports.reviewer": "Reviewer",
  "reports.reviewer_all": "Semua Reviewer",

  "reports.qa_settings_desc": "Atur kategori dan bobot penilaian",

  "reports.total_score": "Total Skor",
  "reports.chat": "Chat",
  "reports.review": "Review",

  "reportsQA.success_update_qa_category":
    "Kategori Quality Assurance berhasil diubah",
  "reportsQA.success_update_qa_category_status":
    "Status kategori Quality Assurance berhasil diubah",
  "reportsQA.success_create_qa_category":
    "Kategori Quality Assurance berhasil ditambahkan",
  "reportsQA.success_delete_qa_category":
    "Kategori Quality Assurance berhasil dihapus",
  "reportsQA.success_move_qa_category":
    "Posisi kategori Quality Assurance berhasil diperbarui",

  "reportsQA.add_category_qa_title": "Tambah Kategori Quality Assurance",
  "reportsQA.edit_category_qa_title": "Ubah Kategori Quality Assurance",
  "reportsQA.required_title": "Judul wajib diisi",
  "reportsQA.required_description": "Deskripsi wajib diisi",

  "reportsQA.placeholder_title": "cth., Customer Service Skills",
  "reportsQA.placeholder_description": "Masukkan deskripsi",
  "reportsQA.weight_percentage": "Bobot (dalam persen)",
  "reportsQA.required_weight_percentage": "Bobot wajib diisi",
  "reportsQA.weight_percentage_exceed":
    "Total bobot tidak boleh lebih dari {{max}}%",
  "reportsQA.weight_percentage_must_positive": "Bobot harus bernilai positif",
  "reportsQA.tooltip_max_weight_percentage":
    "Total bobot maksimal adalah {{max}}%",
  "reportsQA.btn_max": "Maks",
  "reportsQA.is_active": "Aktif",

  "QA.start_review": "Mulai Penilaian",
  "QA.recent_reviews": "Penilaian yang telah dilakukan 30 hari terakhir",
  "QA.percentage_of_reviews": "Persentase penilaian yang telah dilakukan",
  "QA.total_reviews": "Jumlah penilaian yang telah dilakukan",
  "QA.percentage_review_value": "Persentase Review: {{value}}%",
  "QA.total_review_value": "Jumlah Review: {{value}} penilaian",
  "QA.percentage": "Persentase",
  "QA.total": "Jumlah",

  "QA.review_conversation": "Penilaian Percakapan",
  "QA.select_division": "Pilih divisi yang akan direview",
  "QA.division_required": "Divisi wajib diisi",
  "QA.select_division_placeholder": "Pilih divisi",
  "QA.conversation_date": "Tanggal Percakapan",
  "QA.conversation_date_required": "Tanggal percakapan wajib diisi",
  "QA.next_btn": "Selanjutnya",
  "QA.success_submit_review": "Penilaian berhasil disimpan",
  "QA.category_placeholder": "Masukkan tanggapan Anda",
  "QA.agent_required": "Agen wajib diisi",
  "QA.select_agent": "Cth. A",
  "QA.done_btn": "Selesai",

  "QA.category": "Kategori",
  "QA.all_category": "Semua Kategori",
  "QA.no_category": "Tidak ada kategori",
  "QA.category_score": "Skor Kategori",
  "QA.to": "sampai",
  "attachment.template": "Lampiran Template",
  "attachment.image": "Lampiran [Foto]",
  "attachment.docs": "Lampiran [Dokumen]",
  "warning.unsupported_file_type_image":
    "Format file gambar tidak didukung, Silakan gunakan file gambar umum",
  "warning.unsupported_file_type_docs":
    "Format file dokumen tidak didukung, Silakan gunakan file dokumen umum",
  "warning.file_size_limit":
    "File {{type}} harus lebih kecil dari {{value}}MB!",
  "success.upload_file": "File {{value}} berhasil diunggah",
  "warning.required_upload": "Silakan unggah file {{value}}",
  "btn.upload": "Klik untuk mengunggah",
  attachment: "Lampiran",
  "warning.supported_media":
    "File yang didukung: Gambar - Maks {{image}}, Dokumen - Maks {{document}}",
  "warning.all_media": "Maaf, media yang anda unggah tidak didukung.",
  "failed.upload_file": "File {{value}} gagal diunggah. {{message}}",
  "contact.block_description":
    "Kontak ini diblokir, Anda tidak dapat menerima pesan dari kontak ini",
  "contact.block_confirmation": "Apakah anda yakin memblokir kontak ini?",
  "contact.unblock_confirmation":
    "Apakah anda yakin membuka blokir kontak ini?",
  "contact.block_success": "Kontak berhasil diblokir",
  "contact.block_failed": "Kontak tidak dapat diblokir",
  "contact.unblock_success": "Berhasil membuka blokir kontak",
  "contact.unblock_failed": "Tidak dapat membuka blokir kontak",
  "btn.block": "Blokir",
  "btn.unblock": "Buka Blokir",
  otp_verification_channel_label: "Kirim ulang kode ke kontak yang terdaftar",
  otp_resend_via_registered_contact:
    "Kode OTP telah dikirim ulang ke {{channel}} yang terdaftar.",

  "QA.comment": "Komentar",
  "QA.detail_review": "Detil Penilaian",
  "QA.delete_review_confirm": "Apakah anda yakin menghapus penilaian ini?",
  "QA.delete_review_success": "Penilaian berhasil dihapus",

  "popconfirm.title.submit_and_next":
    "Apakah Anda yakin untuk submit dan melanjutkan penilaian ini?",
  "QA.skip_confirmation": "Jangan tampilkan konfirmasi ini lagi",

  "settings.quality_assurance": "Atur kategori Quality Assurance",
  "permission.quality_assurance": "Quality Assurance",
  "permission.setting_quality_assurance": "Quality Assurance",

  "QA.title_notfound": "Tidak ditemukan percakapan",
  "QA.title_notfound_description":
    "Maaf, tidak ditemukan percakapan direntang waktu ini, silakan pilih rentang waktu lain.",
  "QA.title_complete": "Semua percakapan sudah direview",
  "QA.title_complete_description": "Terima kasih sudah mereview percakapan.",

  "popconfirm.title.submit_and_finish":
    "Apakah Anda yakin untuk submit dan menyelesaikan penilaian ini?",
  "QA.title_save_next": "Simpan & Selanjutnya",
  "QA.title_save_finish": "Simpan & Selesai",
  "QA.title_cancel": "Batal",
  "forbidden_page.message":
    "Maaf, Anda tidak mempunyai akses untuk halaman ini.",

  "assign.notes": "Catatan",
  "assign.notes_placeholder": "Masukkan catatan",
  ticketing: "Ticketing",
  "ticketing.title": "Judul",
  "ticketing.add_ticket": "Tambah Tiket",
  "permission.delete_quality_assurance": "Hapus Quality Assurance",
  "permission.delete_quality_assurance_failed":
    "Anda tidak mempunyai akses untuk menghapus penilaian",
  invalid_email_address_format: "Format alamat email tidak valid.",

  "reports.detail-auto-transfer-conversation": "Detil Transfer Chat Otomatis",
  "ticketing.successfully_add_comment": "Berhasil menambahkan komentar",
  "ticketing.error_add_comment": "Gagal menambahkan komentar",
  "ticketing.successfully_delete_comment": "Berhasil menghapus komentar",
  "ticketing.error_delete_comment": "Gagal menghapus komentar",
  "ticketing.to": "Kepada",
  "ticketing.send": "Kirim",
  "ticketing.cancel": "Batal",
  "ticketing.reply": "Balas",
  "ticketing.write_reply": "Tulis Balasan",
  "ticketing.back": "Kembali",
  "ticketing.successfully_update_due_date": "Berhasil mengubah batas respons",
  "ticketing.error_update_due_date": "Gagal mengubah batas respons",
  "ticketing.created_by": "Dibuat oleh",
  "ticketing.last_response": "Terakhir Respons",
  "ticketing.due_date": "Batas Respons",
  "ticketing.update_due_date": "Ubah Batas Respons",
  "ticketing.select_due_date": "Pilih tanggal batas respons",
  "ticketing.due_date_required": "Batas respons harus diisi",
  "ticketing.properties": "Properti",
  "ticketing.tag": "Tag",
  "ticketing.select_tag": "Pilih Tag",
  "ticketing.contact_tag": "Tag Kontak",
  "ticketing.select_contact_tag": "Pilih Tag Kontak",
  "ticketing.category": "Kategori",
  "ticketing.select_category": "Pilih Kategori",
  "ticketing.status": "Status",
  "ticketing.select_status": "Pilih Status",
  "ticketing.priority": "Prioritas",
  "ticketing.select_priority": "Pilih Prioritas",
  "ticketing.priority_required": "Prioritas harus diisi",
  "ticketing.assigned_agent": "Agent yang ditugaskan",
  "ticketing.select_agent": "Pilih Agent",
  "ticketing.update": "Update",

  "ticketing.all": "Semua",
  "ticketing.overdue": "Terlambat",
  "ticketing.approaching_due": "Mendekati Jatuh Tempo",
  "ticketing.no_due_date": "Tidak Ada Jatuh Tempo",
  "ticketing.unassigned": "Tidak Ditugaskan",
  "ticketing.assigned_to_me": "Ditugaskan kepada saya",
  "ticketing.assigned_to_team": "Ditugaskan kepada tim",
  "ticketing.last_hour": "Dalam {{value}} jam terakhir",
  "ticketing.last_day": "Dalam {{value}} hari terakhir",
  "ticketing.last_week": "Dalam {{value}} minggu terakhir",

  "ticketing.recent_activity": "Aktivitas Terbaru",
  "ticketing.select_recent_activity": "Pilih Aktivitas Terbaru",
  "ticketing.sla_status": "Status SLA",
  "ticketing.select_sla_status": "Pilih Status SLA",
  "ticketing.assignment_status": "Status Tugas",
  "ticketing.select_assignment_status": "Pilih Status Tugas",
  "ticketing.has_comments": "Memiliki Komentar",
  "ticketing.select_has_comments": "Pilih Memiliki Komentar",
  "ticketing.has_attachments": "Memiliki Lampiran",
  "ticketing.select_has_attachments": "Pilih Memiliki Lampiran",
  "ticketing.contact": "Kontak",
  "ticketing.select_contact": "Pilih Kontak",
  "ticketing.select_assigned_agent": "Pilih Agent yang ditugaskan",
  "ticketing.created_at": "Dibuat",
  "ticketing.updated_at": "Diperbarui",

  "ticketing.filter_options": "Opsi Filter",
  "ticketing.filter": "Filter",
  "ticketing.reset_filter": "Reset Filter",
  "ticketing.save": "Simpan",

  "ticketing.source": "Sumber",
  "ticketing.select_source": "Pilih Sumber",
  "ticketing.enter_title": "Masukkan judul",
  "ticketing.please_input_title": "Judul wajib diisi",
  "ticketing.enter_description": "Tulis deskripsi...",
  "ticketing.please_select_status": "Status wajib diisi",
  "ticketing.please_select_priority": "Prioritas wajib diisi",
  "ticketing.please_select_source": "Sumber wajib diisi",

  "ticketing.ticket": "Tiket",
  "ticketing.customer": "Pelanggan",
  "ticketing.ticket_detail": "Detail Tiket",
  "ticketing.tickets": "Tiket",
  "ticketing.description": "Deskripsi",
  "ticketing.attachment": "Lampiran",

  "ticketing.ticket_created": "Tiket berhasil dibuat",
  "ticketing.ticket_created_failed": "Tiket gagal dibuat",

  "ticketing.add_tag_ticketing": "Tambah Tag",
  "ticketing.tag_created": "Tag berhasil dibuat",
  "ticketing.tag_created_failed": "Tag gagal dibuat",
  "ticketing.required_tag_name": "Nama tag wajib diisi",
  "ticketing.enter_tag_name": "Masukkan nama tag",
  "ticketing.select_color": "Pilih warna",
  "ticketing.required_tag_color": "Warna tag wajib diisi",

  "ticketing.show_deleted": "Tampilkan Dihapus",
  "ticketing.yes": "Ya",
  "ticketing.no": "Tidak",

  "ticketing.successfully_delete_ticket": "Tiket berhasil dihapus",
  "ticketing.error_delete_ticket": "Tiket gagal dihapus",
  export_successful: "Export berhasil didownload",
  export_failed: "Export gagal didownload",
  "billing.remaining_balance_notification":
    "Saldo tersisa {{balance}} mohon segera topup saldo",
  "billing.chat_not_available": "Chat Tidak Tersedia",
  "billing.balance_exhausted_message":
    "Saldo Anda telah habis. Mohon lakukan top up saldo terlebih dahulu untuk melanjutkan penggunaan layanan chat.",
  "QA.no_more_previous_messages": "Tidak ada pesan sebelumnya",
  "ticketing.ticket_not_found": "Tiket tidak ditemukan",
  "ticketing.ticket_not_found_subtitle":
    "Maaf, tiket tidak ditemukan atau telah dihapus",
  "ticketing.slug_already_used": "Slug sudah digunakan",
  "ticketing.edit_tab": "Edit Tab",
  "ticketing.add_new_tab": "Tambah Tab",
  "ticketing.title_required": "Judul wajib diisi",
  "ticketing.title_placeholder": "Contoh: Tiket Urgent, Tiket Pending, dll",
  "ticketing.slug_required": "Slug wajib diisi",
  "ticketing.slug_pattern":
    "Slug hanya boleh mengandung huruf kecil, angka, dash (-), dan underscore (_)",
  "ticketing.slug": "Slug",
  "ticketing.slug_tooltip":
    "Slug digunakan untuk URL. Hanya boleh mengandung huruf kecil, angka, dash (-), dan underscore (_)",
  "ticketing.slug_placeholder": "Contoh: urgent-tickets, pending-tickets, dll",
  "ticketing.default_filters": "Filter Default",
  "ticketing.configure_filters": "Atur Filter Default",
  "ticketing.filters_default_required":
    "Filter default wajib diisi minimal satu",
  "ticketing.deleted_at": "Dihapus pada {{value}}",
  "ticketing.preview": "Pratinjau",
  export_successful_user_ratings: "Export Rating Pengguna berhasil didownload",
  export_failed_user_ratings: "Export Rating Pengguna gagal didownload",
  "error.failed_to_get_data_from_facebook":
    "Gagal mendapatkan data dari Facebook",
  "error.failed_to_connect_whatsapp":
    "Terjadi kesalahan saat menghubungkan WhatsApp",
  "whatsapp.success_connect_to_server":
    "WhatsApp berhasil terhubung dengan server crm.id",
  "error.failed_to_connect_whatsapp_to_server":
    "Terjadi kesalahan saat menghubungkan WhatsApp dengan server crm.id",
  "whatsapp.complete_information_channel":
    "Lengkapi Informasi Channel WhatsApp",
  "whatsapp.name_channel": "Nama Channel",
  "whatsapp.name_channel_tooltip":
    "Nama harus sesuai dengan yang Anda daftarkan di Facebook",
  "whatsapp.please_input_name_channel": "Mohon masukkan nama channel",
  "whatsapp.input_name_channel": "Masukkan nama channel",
  "whatsapp.phone_number_channel": "Nomor Telepon Channel",
  "whatsapp.phone_number_channel_tooltip":
    "Nomor telepon harus sesuai dengan yang Anda daftarkan di Facebook",
  "whatsapp.please_input_phone_number_channel": "Mohon masukkan nomor telepon",
  "whatsapp.input_phone_number_channel": "Masukkan nomor telepon",
  "whatsapp.invalid_phone_number_format": "Format nomor telepon tidak valid",

  "webhook.title": "Webhook",
  webhook: "Webhook",
  "webhook.subtitle":
    "Terima notifikasi perubahan data secara real-time tanpa perlu memanggil API.",
  "webhook.configuration": "Konfigurasi Webhook",
  "webhook.configuration_subtitle":
    "Untuk mendapatkan notifikasi saat ada perubahan data, Anda perlu menyiapkan endpoint webhook untuk aplikasi Anda",

  "webhook.url_cannot_be_the_same_as_the_original_webhook_url":
    "URL tidak boleh sama dengan URL verifikasi",
  "webhook.url_must_use_https": "URL harus menggunakan HTTPS",
  "webhook.url_must_have_valid_structure":
    "URL harus memiliki struktur yang valid",
  "webhook.url_must_have_endpoint_after_domain":
    "URL harus memiliki endpoint setelah domain",
  "webhook.url_must_start_with_base_url":
    "URL harus dimulai dengan base URL ({{baseUrl}})",
  "webhook.url_must_have_endpoint_after_base_url":
    "URL harus memiliki endpoint setelah base URL ({{baseUrl}})",
  "webhook.url_must_have_single_endpoint_after_base_url":
    "URL harus memiliki satu endpoint setelah base URL ({{baseUrl}})",
  "webhook.edit_webhook": "Edit Webhook",
  "webhook.url": "URL",
  "webhook.url_required": "URL harus diisi",
  "webhook.url_example": "contoh: {{url}}",
  "webhook.save": "Simpan",
  "webhook.script_example_title": "Contoh Script",
  "webhook.script_example_subtitle":
    "Download contoh penggunaan webhook dalam beberapa bahasa pemrograman berikut:",
  "webhook.script_download_success": "Script berhasil diunduh",
  "webhook.script_copy_success": "Script berhasil disalin",
  "webhook.script_copy_error": "Gagal menyalin script",
  "webhook.test_webhook_success": "Berhasil menguji webhook",
  "webhook.object": "Object",
  "webhook.test": "Test",
  "webhook.subscribed": "Subscribed",
  "webhook.callback_url": "Callback URL",
  "webhook.callback_url_tooltip":
    "Berikut adalah seluruh objek yang dapat Anda terima notifikasinya melalui webhook",
  "webhook.copy_signature_secret_success": "Signature secret berhasil disalin",
  "webhook.copy_signature_secret_error": "Gagal menyalin signature secret",
  "webhook.regenerate_signature_secret_success":
    "Berhasil memperbarui signature secret",
  "webhook.regenerate_signature_secret_error":
    "Gagal memperbarui signature secret",
  "webhook.regenerate_signature_secret": "Request ulang signature secret",
  "webhook.verify_webhook_success": "Berhasil memverifikasi callback URL",
  "webhook.verify_webhook_error": "Gagal memverifikasi callback URL",
  "webhook.setup_url_webhook_success": "Berhasil memperbarui callback URL",
  "webhook.setup_url_webhook_error": "Gagal memperbarui callback URL",
  "webhook.activate_webhook": "Aktifkan Webhook",
  "webhook.activate_webhook_success": "Berhasil mengaktifkan webhook",
  "webhook.activate_webhook_error": "Gagal mengaktifkan webhook",
  "webhook.callback_url_description":
    "Ini merupakan URL yang akan dipanggil oleh CRM saat terdapat perubahan data.",
  "webhook.signature_secret": "Signature Secret",
  "webhook.signature_secret_tooltip":
    "Signature secret ini hanya akan ditampilkan sekali",
  "webhook.verify": "Verifikasi",
  "webhook.update_webhook_settings_success":
    "Berhasil memperbarui callback URL",
  "webhook.update_webhook_settings_error": "Gagal memperbarui callback URL",
  wa_message_webhook_url: "Webhook Pesan",
  wa_message_status_webhook_url: "Webhook Status Pesan",
  "inbox-ticketing": "Inbox Ticketing",
  "inbox-ticketing.delete_success": "Berhasil menghapus inbox ticketing",
  "inbox-ticketing.delete_failed": "Gagal menghapus inbox ticketing",
  "inbox-ticketing.update_success": "Berhasil memperbarui inbox ticketing",
  "inbox-ticketing.update_failed": "Gagal memperbarui inbox ticketing",
  "inbox-ticketing.add_success": "Berhasil menambahkan inbox ticketing",
  "inbox-ticketing.add_failed": "Gagal menambahkan inbox ticketing",
  "inbox-ticketing.is_active": "Aktif",
  "settings.inbox_ticketing": "Atur Inbox Ticketing Anda",
  "ticketing.attachment_tooltip":
    "File harus file type: jpg, jpeg, pdf, png, gif, doc, docx, xls, xlsx, dan Maksimal 10MB",
  "ticketing.attachment_error_file_type": "File harus file type: {{value}}",
  "ticketing.attachment_error_file_size":
    "File harus file size: Maksimal {{value}}MB",
  "settings.webhook": "Sambungkan aplikasi Anda dengan webhook",
  "conversation.filter_open": "Open",
  "conversation.filter_closed": "Closed",

  "ticketing.comment_or_attachment_required":
    "Harap isi komentar atau lampirkan file",
  "ticketing.move_to_inbox": "Pindah Inbox",
  "ticketing.select_inbox": "Pilih Inbox",
  "ticketing.inbox_required": "Inbox harus dipilih",
  "ticketing.select_inbox_placeholder": "Pilih inbox tujuan",
  "ticketing.successfully_move_to_inbox": "Berhasil memindahkan tiket ke inbox",
  "ticketing.error_move_to_inbox": "Gagal memindahkan tiket ke inbox",

  "ticketing.notification.new_ticket": "Tiket Baru",
  "ticketing.notification.new_ticket_desc":
    'Tiket baru telah dibuat dengan judul "{{value}}"',
  "ticketing.notification.ticket_assigned": "Tiket Ditugaskan",
  "ticketing.notification.ticket_assigned_desc":
    'Tiket "{{value}}" telah ditugaskan kepada agen',
  "ticketing.notification.ticket_deleted": "Tiket Dihapus",
  "ticketing.notification.ticket_deleted_desc":
    'Tiket "{{value}}" telah dihapus',
  "ticketing.notification.new_comment": "Komentar Baru",
  "ticketing.notification.new_comment_desc":
    'Komentar baru ditambahkan pada tiket "{{value}}"',
  "ticketing.notification.comment_deleted": "Komentar Dihapus",
  "ticketing.notification.comment_deleted_desc":
    'Komentar telah dihapus dari tiket "{{value}}"',

  "ticketing.draft_deleted": "Draft berhasil dihapus",
  "ticketing.draft_applied": "Draft berhasil diterapkan",
  "ticketing.drafts_available": "{{count}} draft tersedia",
  "ticketing.view_drafts": "Lihat Draft",
  "ticketing.saved_drafts": "Draft Tersimpan",
  "ticketing.delete_all_drafts_confirm": "Hapus semua draft?",
  "ticketing.delete_all": "Hapus Semua",
  "ticketing.no_drafts": "Tidak ada draft tersimpan",
  "ticketing.apply": "Terapkan",
  "ticketing.delete_draft_confirm": "Hapus draft ini?",
  "ticketing.untitled": "Tanpa Judul",
  "ticketing.active": "Aktif",
  "ticketing.saved_at": "Disimpan",

  "ticketing.error_update_ticket_title": "Gagal mengubah judul tiket",
  "ticketing.successfully_update_ticket_title": "Berhasil mengubah judul tiket",
  "ticketing.no_tickets_yet": "Belum ada tiket",
  "ticketing.view_detail": "Lihat detail",

  "ticketing.notification.ticket_inbox_changed": "Inbox Tiket Diubah",
  "ticketing.notification.ticket_inbox_changed_desc":
    'Inbox tiket "{{value}}" telah diubah oleh {{user}}',
  "conversation.no_chat_yet": "Belum ada pesan",
  "conversation.please_start_chatting_first":
    "Silahkan mulai pesan terlebih dahulu",

  "ticketing.last_month": "Dalam {{value}} bulan terakhir",
  "apiKey.create_title": "Tambah API Key",
  "apiKey.create_success": "API Key berhasil dibuat",
  "apiKey.create_error": "API Key gagal dibuat",
  "apiKey.name_label": "Nama Token",
  "apiKey.name_placeholder": "Masukkan nama token",
  "apiKey.name_required": "Masukkan nama token",
  "apiKey.name_description":
    "Masukkan nama token yang berhubungan dengan aplikasi yang menggunakan token atau tujuan dari token.",
  "apiKey.max_expiration_date": "Maksimal tanggal kedaluwarsa token",
  "apiKey.detail_title": "Detail API Key",
  "apiKey.not_found_title": "Token tidak ditemukan",
  "apiKey.not_found_subtitle":
    "Maaf, Token tidak ditemukan. Silakan cek kembali.",
  "apiKey.delete_confirm": "Apakah Anda yakin ingin menghapus token ini?",
  "apiKey.delete_success": "Token berhasil dihapus",
  "apiKey.delete_error": "Gagal menghapus token. Silakan coba lagi.",
  "apiKey.name_label_detail": "Nama Token:",
  "apiKey.token_label": "Token:",
  "apiKey.status_label": "Status:",
  "apiKey.status_expired": "Kadaluwarsa",
  "apiKey.status_active": "Aktif",
  "apiKey.expiration_date_label": "Tanggal Kedaluwarsa:",
  "apiKey.last_used_label": "Terakhir Digunakan:",
  "apiKey.last_used_never": "Belum pernah digunakan",
  "apiKey.created_date_label": "Tanggal Dibuat:",
  "apiKey.expiration_date_form_label": "Tanggal Kedaluwarsa",
  "apiKey.expiration_date_placeholder": "Pilih tanggal kedaluwarsa",
  "apiKey.expiration_date_required": "Pilih tanggal kedaluwarsa",
  "apiKey.expiration_days": "{{days}} Hari",
  "apiKey.expiration_years": "{{years}} Tahun",
  "apiKey.expiration_custom": "Custom",
  "apiKey.date_preset_tomorrow": "Besok",
  "apiKey.date_preset_next_week": "Minggu Depan",
  "apiKey.date_preset_next_month": "Bulan Depan",
  "apiKey.date_preset_next_year": "Tahun Depan",
  "apiKey.guide_button": "Panduan",
  "apiKey.description":
    "Anda dapat membuat personal access token untuk setiap aplikasi yang membutuhkan token saat diintegrasikan dengan Kledo.",
  "apiKey.stats_active": "Token aktif",
  "apiKey.stats_expired": "Token kedaluwarsa",
  "apiKey.stats_never_used": "Token belum pernah digunakan",
  "apiKey.table_name": "Nama Token",
  "apiKey.table_token": "Token",
  "apiKey.table_created_date": "Tanggal Dibuat",
  "apiKey.table_last_used": "Tanggal Terakhir Digunakan",
  "apiKey.table_expiration_date": "Tanggal Kedaluwarsa",
  "apiKey.table_action": "Aksi",
  "apiKey.overview_title": "API Overview",
  "apiKey.overview_endpoint_label": "API Endpoint URL:",
  "apiKey.overview_documentation_label": "Dokumentasi API Endpoint:",
  "apiKey.overview_script_label": "PHP Demo Script:",
  "apiKey.copy_button_title": "Copy",
  "apiKey.script_copied_fallback": "Script telah disalin",
  "apiKey.token_alert_title": "Personal Access Token Anda",
  "apiKey.token_alert_description":
    "Silahkan salin dan simpan kode token diatas, kode token ini hanya dapat diakses satu kali",
  "apiKey.token_copied": "Token berhasil disalin",
  "billing.choose_plan": "Pilih Paket",
  "billing.choose_term": "Pilih Lama Kontrak",
  "billing.add_addon": "Tambah Addon",
  "billing.hide_addon": "Sembunyikan Addon",
  "billing.calculation_detail": "Rincian Perhitungan",
  "billing.total_bill": "Total tagihan",
  "billing.upgrade_now": "Upgrade Sekarang",
  "billing.renew_now": "Perpanjang Sekarang",
  "billing.most_popular": "Paling Banyak Dipilih",
  "billing.discount_percent": "Diskon {{value}}%",
  "billing.save_amount": "Hemat {{value}}",
  "billing.per_month": "/bulan",
  "billing.term_months": "{{value}} Bulan",
  "billing.term_years": "{{value}} Tahun",
  "billing.whatsapp_channels": "{{value}} Channel WhatsApp",
  "billing.chat_rows": "{{value}} Baris chat",
  "billing.subtotal_plan": "Subtotal Paket",
  "billing.subtotal_addon": "Subtotal Addon",
  "billing.subtotal": "Subtotal",
  "billing.saving_label": "Penghematan",
  "billing.discount_label": "Diskon",
  "billing.upgrade_success": "Order upgrade berhasil dibuat",
  "billing.renew_success": "Order perpanjangan berhasil dibuat",
  "billing.no_plan_available": "Paket upgrade tidak tersedia",
  "billing.payment_success": "Pembayaran berhasil",
  "billing.payment_pending":
    "Pembayaran sedang diproses, silakan selesaikan pembayaran",
  "billing.payment_error": "Pembayaran gagal, silakan coba lagi",
  "billing.payment_cancelled": "Pembayaran dibatalkan",
  "billing.token_required_to_make_payment":
    "Token diperlukan untuk melakukan pembayaran",
  "billing.payment_gateway_not_ready":
    "Gateway pembayaran belum siap, silakan refresh halaman",
  "billing.upgrade_disclaimer":
    "Dengan klik tombol di atas, Anda setuju dengan <terms>Ketentuan Penggunaan</terms> kami dan mengonfirmasi bahwa Anda telah membaca <privacy>Kebijakan Privasi</privacy> kami.",
  "billing.thank_you": "Terimakasih",
  "billing.email_invoice_sent":
    "Email tagihan telah dikirimkan ke alamat email Anda.",
  "billing.please_pay_amount":
    "Silakan melakukan pembayaran sebesar <b>{{value}}</b> dengan klik tombol berikut",
  "billing.back_to_billing": "Kembali ke Billing",
  "billing.pay_now": "Bayar Sekarang",
  "billing.subtitle": "Kelola penggunaan dan riwayat pembayaran Anda.",
  "billing.export_invoice": "Export Invoice",
  "billing.on_demand_section": "Saldo On Demand",
  "billing.subscription_section": "Saldo Berlangganan",
  "billing.outstanding_balance": "Outstanding Balance",
  "billing.outstanding_balance_tooltip":
    "Saldo yang dapat Anda gunakan untuk menjalankan layanan on demand.",
  "billing.current_usage_monthly": "Penggunaan Bulan Ini",
  "billing.current_usage_monthly_tooltip":
    "Total penggunaan layanan pada bulan berjalan.",
  "billing.total_conversation": "Total Percakapan (Chat)",
  "billing.total_conversation_tooltip":
    "Jumlah total percakapan chat yang pernah dijalankan.",
  "billing.balance_negative": "Saldo Anda negatif",
  "billing.balance_sufficient": "Saldo Anda aman",
  "billing.please_topup": "Silakan top up saldo Anda",
  "billing.no_comparison_data": "Belum ada data pembanding bulan lalu",
  "billing.compared_to_last_month": "{{value}}% dibanding bulan lalu",
  "billing.total_chat_until_now": "Total chat hingga saat ini",
  "billing.current_plan": "Paket Saat Ini",
  "billing.subscription_plan_name": "Paket {{value}}",
  "billing.no_action_available":
    "Tidak ada tindakan tersedia untuk paket ini saat ini.",
  "billing.no_subscription_data": "Data langganan belum tersedia",
  upgrade: "Upgrade",
  "billing.col_product": "Produk",
  "billing.col_qty": "Jumlah",
  "billing.col_term": "Kontrak",
  "billing.col_per_month": "Perbulan",
  "billing.on_demand": "On Demand",
  "billing.subscription": "Langganan",
  "billing.col_order_date": "Tanggal Order",
  "billing.col_period": "Periode",
  "billing.col_paid_date": "Tanggal Bayar",
  "billing.col_status": "Status",
  "billing.status_paid": "Lunas",
  "billing.status_unpaid": "Belum Dibayar",
  "billing.pay": "Bayar",
  "billing.download_invoice": "Unduh Invoice",
  "billing.delete_transaction_success": "Transaksi berhasil dihapus",
  "billing.payment_waiting_title": "Menunggu Pembayaran",
  "billing.payment_waiting_desc":
    "Akun Anda akan aktif setelah dilakukan pembayaran. Jika Anda telah melakukan pembayaran, silakan klik tombol berikut. Terimakasih.",
  "billing.go_to_crm": "Pergi ke CRM",
  "billing.go_to_billing": "Pergi ke Billing CRM",
  "billing.payment_success_title": "Pembayaran Berhasil",
  "billing.payment_success_desc": "Akun Anda telah diaktifkan. Terima kasih.",
  "billing.active_plan": "Paket Aktif",
  "billing.no_addon": "Belum ada addon tersedia untuk langganan ini.",
  "billing.addon": "Addon",
  "billing.active_until": "Aktif sampai",
  "billing.forever": "Selamanya",
  "billing.current_usage_title": "Penggunaan Saat Ini",
  "billing.features_title": "Fitur Yang Anda Dapatkan",
  "billing.view_plan_detail": "Lihat Detail Paket",
  "billing.status_active": "Aktif",
  "billing.channel_whatsapp": "Channel WhatsApp",
  "billing.chat_rows_label": "Baris Chat",
  "billing.unit_channel": "Channel",
  "billing.unit_rows": "Baris",
  "billing.on_demand_desc": "Kelola saldo dan penggunaan On Demand Anda.",
  "billing.addon_section": "Add-on",
  "billing.addon_section_desc":
    "Tambah add-on untuk menambah kapasitas layanan tanpa mengubah paket langganan Anda.",
  "billing.no_addon_available": "Belum ada addon yang tersedia untuk dibeli.",
  "billing.no_subscribed_addon": "Belum ada addon berlangganan.",
  "billing.addon_title": "Tambah Add-on",
  "billing.choose_addon": "Pilih Add-on",
  "billing.buy_now": "Beli Sekarang",
  "billing.addon_success": "Order add-on berhasil dibuat",
  "billing.addon_empty_selection":
    "Pilih add-on dan tentukan jumlahnya untuk melihat rincian.",
  "billing.addon_free_limit_reached":
    "Paket Free tidak bisa menambah add-on. Upgrade ke paket berbayar dulu untuk membeli add-on.",
  addon: "Add-on",
  "billing.col_unit_price": "Harga Satuan",
  otp_change_email_old_label: "Kode OTP dari email lama",
  otp_change_email_new_label: "Kode OTP dari email baru",
  // [crm-iso] START — hidden feature (lihat CrmIsoSetting/TEARDOWN.md)
  "crm_iso.title": "Pengaturan CRM ISO",
  "crm_iso.subtitle":
    "Kelola provider & agen terpengaruh serta pemetaan nama agen. Setiap perubahan tersimpan otomatis.",
  "crm_iso.add": "Tambah",
  "crm_iso.cancel": "Batal",
  "crm_iso.delete": "Hapus",
  "crm_iso.confirm_delete_title": "Hapus data ini?",
  "crm_iso.confirm_delete_agent_with_mapping_title":
    "Hapus agen terpengaruh ini?",
  "crm_iso.confirm_delete_agent_with_mapping_desc":
    "Agen ini dipakai sebagai agen utama pada pemetaan nama agen. Menghapusnya akan menghapus pemetaan tersebut juga.",
  "crm_iso.col_action": "Aksi",
  "crm_iso.toggle": "Aktifkan Fitur",
  "crm_iso.toggle_desc": "Aktifkan atau nonaktifkan fitur CRM ISO.",
  "crm_iso.on": "Aktif",
  "crm_iso.off": "Nonaktif",
  "crm_iso.affected_agents": "Agen Terpengaruh",
  "crm_iso.affected_agents_desc":
    "Daftar agen yang termasuk dalam cakupan fitur ini.",
  "crm_iso.add_agent": "Tambah Agen",
  "crm_iso.col_agent_name": "Nama Agen",
  "crm_iso.empty_agents": "Belum ada agen",
  "crm_iso.select_agent_hint":
    "Pilih satu atau beberapa agen untuk ditambahkan.",
  "crm_iso.agent_name_changes": "Pemetaan Nama Agen",
  "crm_iso.agent_name_changes_desc":
    "Tetapkan satu agen utama yang mewakili beberapa agen tergabung.",
  "crm_iso.add_agent_name_change": "Tambah Pemetaan",
  "crm_iso.edit_agent_name_change": "Edit Pemetaan",
  "crm_iso.save": "Simpan",
  "crm_iso.main_agent": "Agen Utama",
  "crm_iso.main_agent_hint":
    "Dipilih dari daftar agen terpengaruh, hanya boleh satu.",
  "crm_iso.select_main_agent": "Pilih agen utama",
  "crm_iso.connected_agents": "Agen Tergabung",
  "crm_iso.select_connected_agents": "Pilih agen tergabung",
  "crm_iso.main_included_note":
    "Agen utama otomatis termasuk sebagai agen tergabung.",
  "crm_iso.mapping_flow_hint":
    "Pilih agen utama terlebih dahulu untuk mulai memetakan.",
  "crm_iso.col_main_agent": "Agen Utama",
  "crm_iso.col_connected_agents": "Agen Tergabung",
  "crm_iso.empty_agent_name_changes": "Belum ada pemetaan",
  "crm_iso.no_affected_agents_hint":
    "Tambahkan agen terpengaruh terlebih dahulu.",
  "crm-iso-setting": "Pengaturan CRM ISO",
  "crm_iso.col_agent_email": "Email",
  // [crm-iso] END
  "import_contact.title": "Import Kontak",
  "import_contact.button": "Import",
  "import_contact.step_upload": "Upload File",
  "import_contact.step_check": "Cek Data",
  "import_contact.step_progress": "Import sedang berlangsung",
  "import_contact.step_success": "Import Berhasil",
  "import_contact.instruction_title":
    "Ikuti langkah-langkah berikut untuk meng-import kontak",
  "import_contact.step1_title": "Download file template kontak",
  "import_contact.step1_desc":
    "Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang dibutuhkan CRM ID untuk mengimport detail dari kontak-mu.",
  "import_contact.download_template": "Download File Template",
  "import_contact.download_example": "Download File Contoh",
  "import_contact.step2_title": "Salin detail kontak ke dalam template",
  "import_contact.step2_desc":
    "Menggunakan Excel atau software spreadsheet lainnya, masukkan detail kontak ke dalam file template dari CRM ID. Pastikan detail kontak sesuai dengan kolom header yang ada di template.",
  "import_contact.important": "PENTING :",
  "import_contact.important_1":
    "Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.",
  "import_contact.important_2":
    "Maksimal 3.000 kontak dapat diimport dalam satu waktu.",
  "import_contact.important_3":
    "Kamu juga dapat menggunakan file yang sudah diimport untuk mengupdate semua kontakmu, menghemat waktu dan tenaga daripada mengupdate kontak satu persatu melalui browser.",
  "import_contact.important_4":
    "Proses import akan menggunakan Nama Kontak, Perusahaan, dan Tipe kontak untuk menentukan apakah suatu kontak sudah ada atau belum, jika kontak sudah ada maka kontak akan diupdate, sedangkan jika kontak belum ada maka akan dibuat kontak baru. Kontak tidak akan dihapus, sehingga kamu bisa dengan aman mengupdate sebagian kontakmu saja tanpa khawatir akan kehilangan data di kontak yang lain.",
  "import_contact.step3_title": "Upload template yang sudah diupdate ke sini",
  "import_contact.step3_desc": "Simpan file template yang sudah diupdate :",
  "import_contact.upload_hint": "Drag file di sini untuk upload",
  "import_contact.upload": "Upload",
  "import_contact.check_title": "Silakan cek data yang diimport",
  "import_contact.check_desc":
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  "import_contact.valid": "Valid",
  "import_contact.invalid": "Invalid",
  "import_contact.total": "Total",
  "import_contact.import_now": "Import Sekarang",
  "import_contact.row": "Baris",
  "import_contact.error_message": "Kesalahan",
  "import_contact.col_address": "Alamat Penagihan",
  "import_contact.col_birthday": "Tanggal Lahir",
  "import_contact.col_error": "Error",
  "import_contact.valid_detail_unavailable":
    "Detail baris valid tidak tersedia untuk ditampilkan.",
  "import_contact.progress_title": "Import sedang berlangsung",
  "import_contact.progress_desc":
    "Tidak apa-apa untuk menutup halaman ini atau mengimport file lain. Ketika import selesai, Anda akan diberitahu melalui email.",
  "import_contact.preparing": "Mempersiapkan proses impor",
  "import_contact.progress_count": "{{count}} dari {{total}} baris diproses",
  "import_contact.import_other": "Import file lain",
  "import_contact.back_to_list": "Ke halaman daftar kontak",
  "import_contact.success_title": "Import Berhasil",
  "import_contact.success_count": "{{count}} baris kontak berhasil diimport.",
  "import_contact.show_detail": "Tampilkan detil",
  "import_contact.hide_detail": "Sembunyikan detil",
  "import_contact.succeed": "Berhasil",
  "import_contact.failed": "Gagal",
  "import_contact.err_file_type":
    "Format file harus .csv, .xls, .xlsx, atau .txt",
  "import_contact.err_file_size": "Ukuran file maksimal 10MB",
  "import_contact.upload_failed": "Gagal mengupload file",
  "import_contact.download_failed": "Gagal mengunduh file",
  "companies.select_company": "Pilih Perusahaan",
  "warning.wa_param_no_newline":
    "Baris baru (Enter) tidak diperbolehkan pada isian variabel template WhatsApp.",
  "warning.wa_param_adjusted":
    "Teks yang ditempel disesuaikan agar sesuai ketentuan WhatsApp: baris baru & tab dihapus, spasi berlebih dirapikan.",
  "notification.crm_id_is_now_on_google_play":
    "CRM.ID kini tersedia di Google Play",
  "footer.get_it_on_google_play": "Dapatkan di Google Play",
  "reports.desc_chat_lines_count":
    "Lihat total jumlah baris chat dalam periode tertentu.",
  "reports.desc_online_duration":
    "Analisis durasi online tim dalam periode tertentu.",
  "reports.desc_team_response_time":
    "Lihat rata-rata waktu respon tim terhadap pesan masuk.",
  "reports.desc_individual_response_time":
    "Analisis waktu respon masing-masing individu.",
  "reports.desc_auto_transfer_conversation":
    "Lihat data percakapan yang ditransfer otomatis.",
  "reports.desc_statistics_user_ratings":
    "Ringkasan statistik rating dari pengguna.",
  "reports.desc_list_of_user_ratings":
    "Lihat daftar rating pengguna secara detail.",
  "reports.desc_data_quality_assurance": "Lihat data hasil quality assurance.",
  "reports.desc_statistics_quality_assurance":
    "Analisis statistik hasil quality assurance.",
  "reports.desc_chat_volume_statistics":
    "Lihat statistik volume chat untuk setiap agent.",
  "reports.desc_chat_volume_statistics_daily":
    "Lihat statistik volume chat harian dalam periode tertentu.",
  "reports.need_other_report_title": "Butuh laporan lain?",
  "reports.need_other_report_subtitle":
    "Jika ada kebutuhan laporan tambahan, silakan hubungi administrator.",
  "reports.contact_admin": "Hubungi Admin",
  "reports.search_placeholder": "Cari laporan...",
  "reports.no_report_found": "Laporan tidak ditemukan.",
  "reports.volume_incoming": "Volume Chat Masuk",
  "reports.desc_volume_incoming":
    "Lihat volume chat masuk dalam periode tertentu.",
  "reports.vi_export": "Export",
  "reports.vi_subtitle":
    "Ringkasan jumlah conversation masuk (incoming) pada CRM Kledo.",
  "reports.vi_team": "Team",
  "reports.vi_team_all": "Semua Team",
  "reports.vi_period_label": "Periode",
  "reports.vi_per_hour": "Per Jam",
  "reports.vi_per_day": "Per Hari",
  "reports.vi_per_week": "Per Minggu",
  "reports.vi_per_month": "Per Bulan",
  "reports.vi_kpi_total": "Total Incoming",
  "reports.vi_kpi_avg_day": "Rata-rata / Hari",
  "reports.vi_kpi_peak_hour": "Peak Hour (Rata-rata)",
  "reports.vi_kpi_active_agents": "Total Agent Aktif",
  "reports.vi_kpi_avg_agent_day": "Rata-rata / Agent / Hari",
  "reports.vi_section_heatmap": "Heatmap Incoming Per Jam",
  "reports.vi_section_heatmap_daily": "Kalender Incoming Harian",
  "reports.vi_section_heatmap_weekly": "Heatmap Incoming Mingguan",
  "reports.vi_section_heatmap_monthly": "Heatmap Incoming Bulanan",
  "reports.vi_week": "Minggu",
  "reports.vi_month": "Bulan",
  "reports.vi_section_interval": "Incoming per Interval (Ringkasan)",
  "reports.vi_section_trend": "Tren Incoming",
  "reports.vi_section_detail": "Detail Incoming",
  "reports.vi_event_label": "Jenis Event",
  "reports.vi_event_all": "Semua Event",
  "reports.vi_event_created": "Conversation Baru",
  "reports.vi_event_assign": "Di-assign",
  "reports.vi_event_take": "Diambil Agent",
  "reports.vi_event_auto_transfer": "Transfer Otomatis",
  "reports.vi_kpi_total_sub": "dibanding periode sebelumnya",
  "reports.vi_unit_incoming": "incoming",
  "reports.vi_interval_hour": "Per Jam (Rata-rata)",
  "reports.vi_interval_day": "Per Hari (Total)",
  "reports.vi_interval_week": "Per Minggu (Total)",
  "reports.vi_interval_month": "Per Bulan (Total)",
  "reports.vi_unit_per_hour": "incoming / jam",
  "reports.vi_unit_per_day": "incoming / hari",
  "reports.vi_unit_per_week": "incoming / minggu",
  "reports.vi_unit_per_month": "incoming / bulan",
  "reports.vi_heatmap_less": "Sedikit",
  "reports.vi_heatmap_more": "Banyak",
  "reports.vi_heatmap_hourly_only": "Heatmap tersedia saat periode = Per Jam.",
  "reports.vi_trend_series": "Incoming",
  "reports.vi_col_agent": "Agent",
  "reports.vi_col_team": "Team",
  "reports.vi_col_total": "Total Incoming",
  "reports.vi_col_interval_total": "Total per Interval Jam",
  "reports.vi_col_per_day_avg": "Per Hari (Rata-rata)",
  "reports.vi_col_per_week_avg": "Per Minggu (Rata-rata)",
  "reports.vi_col_per_month_avg": "Per Bulan (Rata-rata)",
  "reports.vi_search_agent": "Cari Agent / Team...",
  "reports.vi_column": "Kolom",
  "reports.vi_export_csv": "Export CSV",
  "reports.vi_unit_day": "hari",
  "reports.vi_unit_month": "bulan",
  "reports.vi_range_clamped":
    "Rentang untuk {{label}} maksimal {{amount}} {{unit}}. Tanggal mulai otomatis disesuaikan.",
  "volume-incoming": "Volume Incoming",
  "apiKey.script_example_title": "Contoh Script",
  "apiKey.script_example_subtitle":
    "Unduh contoh penggunaan API CRM dalam berbagai bahasa pemrograman. Ganti ACCESS_TOKEN dengan token API milik Anda.",
  "apiKey.script_copy_success": "Script berhasil disalin",
  "apiKey.script_copy_error": "Gagal menyalin script",
  "apiKey.script_download_success": "Script berhasil diunduh",
  "conversation.volume_char_warning":
    "Hanya {{limit}} karakter pertama dari setiap balasan chat yang dihitung sebagai volume chat",
  "conversation.volume_not_counted_title":
    "Balasan ini tidak dihitung dalam volume chat.",
  "conversation.volume_not_counted_desc":
    "Hanya baris pertama setelah chat dari customer yang dihitung sebagai volume chat.",
  "bots.node_type": "Jenis node",
  "bots.node_type_reply": "Balasan biasa",
  "bots.node_type_handover": "Lepas ke agent",
  "bots.handover_help":
    "Setelah balasan ini terkirim, bot berhenti dan percakapan diteruskan ke agent.",
  "bots.delete_node": "Hapus",
  "bots.delete_node_confirm_title": 'Hapus node "{{name}}"?',
  "bots.delete_node_confirm_desc":
    "Node ini beserta {{count}} node di bawahnya akan ikut terhapus. Tindakan ini tidak bisa dibatalkan.",
  "bots.delete_node_confirm_desc_leaf":
    "Node ini akan dihapus. Tindakan ini tidak bisa dibatalkan.",
  "chatbot.success_delete_flow": "Node berhasil dihapus",
  "chatbot.error_delete_flow": "Node tidak dapat dihapus",
  "bots.handover_after_fallback": "Lepas ke agent setelah bot tidak paham",
  "bots.handover_after_fallback_help": "kali berturut-turut · 0 = tidak pernah",
  "bots.handover_after_fallback_hint":
    "Kalau customer mengetik sesuatu yang tidak dikenali bot sebanyak N kali berturut-turut, percakapan dilepas ke agent. Balasan setelah customer sampai di jawaban akhir (mis. 'ok', 'makasih') tidak dihitung.",
  "bots.handover_message": "Pesan saat melepas ke agent",
  "bots.handover_message_help":
    'Kosongkan untuk tetap memakai balasan "tidak paham" biasa',
  "bots.back_to_menu_keywords": "Kata kunci kembali ke menu utama",
  "bots.back_to_menu_keywords_hint":
    "Customer yang mengetik salah satu kata ini dibawa kembali ke sambutan dari posisi mana pun",
  "bots.handover_column": "Lepas ke agent",
  "bots.handover_summary_never": "Tidak pernah",
  "bots.handover_summary_after": "Setelah {{count}}× tidak paham",
  "bots.error_handover_after_fallback_integer":
    "Handover after fallback harus berupa integer.",
  "bots.error_handover_after_fallback_min":
    "Handover after fallback minimal 0.",
  "bots.error_handover_after_fallback_max":
    "Handover after fallback harus tidak lebih dari 255.",
  "bots.error_back_to_menu_keywords_max":
    "Back to menu keywords harus tidak lebih dari 20 item.",
  "bots.error_back_to_menu_keyword_empty":
    "Back_to_menu_keywords.{{index}} harus berupa string.",
  "bots.error_back_to_menu_keyword_max":
    "Back_to_menu_keywords.{{index}} harus tidak lebih dari 191 karakter.",
  "ticketing.export": "Ekspor",
  "ticketing.export_to_xlsx": "Ekspor ke XLSX",
  "ticketing.export_to_csv": "Ekspor ke CSV",
  "ticketing.export_successful": "Ekspor tiket berhasil diunduh",
  "ticketing.export_failed": "Ekspor tiket gagal diunduh",
  "reports.vi_no_previous_data": "Tidak ada data sebelumnya",
  "chat_lines_count.incoming": "Pesan Masuk",
  "chat_lines_count.agent_reply": "Balasan Agent",
  "chat_lines_count.bot_reply": "Balasan Bot",
  "chat_lines_count.total": "Total",
  "inhouse_channel.title": "Channel Inhouse",
  "inhouse_channel.description":
    "Pasang live chat di website Anda. Chat dari pengunjung akan masuk ke inbox seperti chat WhatsApp.",
  "inhouse_channel.add_title": "Tambah Channel Inhouse",
  "inhouse_channel.detail_title": "Detail Channel",
  "inhouse_channel.name": "Nama Channel",
  "inhouse_channel.name_placeholder": "mis. Live Chat Website",
  "inhouse_channel.name_required": "Mohon masukkan nama channel",
  "inhouse_channel.allow_guest": "Izinkan Tamu",
  "inhouse_channel.allow_guest_help":
    "Jika dimatikan, hanya pengunjung yang login di website Anda yang bisa chat (butuh endpoint identity di backend website).",
  "inhouse_channel.active": "Aktif",
  "inhouse_channel.inactive": "Nonaktif",
  "inhouse_channel.secret_title": "Simpan Identity Secret",
  "inhouse_channel.secret_warning":
    "Secret ini hanya ditampilkan sekali. Simpan di env backend website Anda. Jangan taruh di HTML/JavaScript.",
  "inhouse_channel.secret_saved": "Sudah saya simpan",
  "inhouse_channel.copied": "Berhasil disalin",
  "inhouse_channel.copy_failed": "Gagal menyalin",
  "inhouse_channel.failed": "Terjadi kesalahan, silakan coba lagi",
  "inhouse_channel.session_ttl_info": "Sesi chat berlaku {{hours}} jam",
  "inhouse_channel.install_title": "Pasang di Website",
  "inhouse_channel.install_desc":
    "Salin snippet berikut dan tempel sebelum </body> di setiap halaman website Anda.",
  "inhouse_channel.snippet_guest": "Mode Tamu",
  "inhouse_channel.snippet_login": "Mode Login",
  "inhouse_channel.confirm_change_title": "Simpan perubahan?",
  "inhouse_channel.confirm_continue": "Lanjutkan",
  "inhouse_channel.deactivate_warning":
    "Menonaktifkan channel akan langsung memutus semua pengunjung yang sedang chat.",
  "inhouse_channel.disallow_guest_warning":
    "Mematikan izin tamu akan langsung menghentikan sesi tamu yang sedang berjalan. Hanya pengunjung yang login yang bisa chat.",
  "inhouse_channel.rotate_secret": "Terbitkan Ulang Identity Secret",
  "inhouse_channel.rotate_confirm_title": "Terbitkan ulang identity secret?",
  "inhouse_channel.rotate_confirm_desc":
    "Secret lama langsung tidak berlaku. Widget mode login di website Anda akan gagal sampai env backend diperbarui. Mode tamu dan snippet tidak berubah.",
  "inhouse_channel.delete": "Hapus Channel",
  "inhouse_channel.delete_confirm_title": "Hapus channel ini?",
  "inhouse_channel.delete_confirm_desc":
    "Widget di website Anda akan berhenti bekerja dan agent tidak bisa lagi mengirim pesan lewat channel ini. Riwayat percakapan tetap bisa dibaca di inbox.",
  "inhouse_channel.add_card_title": "Tambah Channel",
  "inhouse_channel.add_card_desc": "Tambahkan channel baru",
  "inhouse_channel.guest_disabled_info":
    "Izin tamu sedang dimatikan. Snippet mode tamu tidak akan bisa dipakai chat sampai izin tamu diaktifkan kembali.",
  "inhouse_channel.login_cookie": "Website biasa (cookie sesi)",
  "inhouse_channel.login_spa": "SPA (token)",
  "inhouse_channel.spa_step1_title":
    "Langkah 1: buat endpoint identity di backend Anda",
  "inhouse_channel.spa_step1_desc":
    "Endpoint ini dipanggil widget dengan token login user (Authorization: Bearer …) dan mengembalikan { identity_token } untuk user yang login, atau 401 kalau belum login. Simpan identity secret channel ini di env backend (INHOUSE_IDENTITY_SECRET), jangan di frontend.",
  "inhouse_channel.spa_step1_cors":
    "Kalau frontend dan API Anda beda domain, pastikan CORS API Anda mengizinkan header Authorization dari domain frontend.",
  "inhouse_channel.spa_step2_title": "Langkah 2: pasang widget di index.html",
  "inhouse_channel.spa_step2_desc":
    "Tempel sebelum </body>. Sesuaikan dua baris bertanda ← dengan aplikasi Anda.",
  "inhouse_channel.spa_step2_note":
    "Baca token di dalam identify, jangan sekali di awal. Widget memanggilnya lagi setiap kali butuh identitas, jadi token yang dipakai selalu yang terbaru.",
  "inhouse_channel.spa_step3_title":
    "Langkah 3: beri tahu widget saat login dan logout",
  "inhouse_channel.spa_step3_desc":
    "Halaman SPA tidak di-reload saat login/logout, jadi widget harus diberi tahu.",
  "inhouse_channel.spa_step3_warning":
    "Jangan lewatkan logout. Tanpa itu, orang berikutnya di perangkat yang sama bisa membaca chat user sebelumnya.",
  "inhouse_channel.spa_step3_note":
    "Chat yang sempat dikirim sebagai tamu tidak hilang. Setelah login, widget menawarkan untuk menggabungkannya ke akun user.",
  "inhouse_channel.spa_step4_title": "Langkah 4: coba",
  "inhouse_channel.spa_step4_item1":
    "Buka website dalam keadaan belum login, lalu kirim pesan. Pesan masuk ke inbox sebagai tamu.",
  "inhouse_channel.spa_step4_item2":
    "Login. Widget menawarkan untuk menggabungkan chat tamu, lalu pesan berikutnya masuk atas nama user.",
  "inhouse_channel.spa_step4_item3":
    "Logout. Chat user tidak terlihat lagi, dan widget kembali ke mode tamu.",
  "inhouse_channel.spa_step4_note":
    'Kalau muncul banner "Identitas pengguna tidak sah", berarti secret di env backend Anda tidak cocok dengan channel ini. Mungkin secret-nya sudah diterbitkan ulang.',
  "inhouse_channel.login_cookie_desc":
    "PHP, Laravel, Django, WordPress, dan website lain yang login pakai cookie sesi",
  "inhouse_channel.login_spa_desc":
    "React, Vue, Angular, dan aplikasi lain yang login pakai token",
  "inhouse_channel.cookie_step1_title":
    "Langkah 1: buat endpoint identity di backend Anda",
  "inhouse_channel.cookie_step1_desc":
    "Widget memanggil /api/chat-identity dengan cookie sesi login user. Endpoint mengembalikan { identity_token } untuk user yang login, atau 401 kalau belum login. Simpan identity secret channel ini di env backend (INHOUSE_IDENTITY_SECRET), jangan di frontend.",
  "inhouse_channel.cookie_step2_title": "Langkah 2: pasang widget di website",
  "inhouse_channel.cookie_step2_desc":
    "Tempel sebelum </body> di setiap halaman. Kalau URL endpoint Anda bukan /api/chat-identity, sesuaikan data-identity-url.",
  "inhouse_channel.section_settings": "Pengaturan",
  "inhouse_channel.section_credentials": "Kredensial",
  "inhouse_channel.section_danger": "Zona Berbahaya",
  inhouse: "Channel Inhouse",
  "inhouse_channel.section_settings_desc":
    "Informasi dasar dan status channel.",
  "inhouse_channel.section_credentials_desc":
    "Konfigurasi API untuk menghubungkan widget di website Anda.",
  "inhouse_channel.name_help": "Nama ini akan ditampilkan di halaman channel.",
  "inhouse_channel.active_help":
    "Jika dimatikan, channel tidak akan menerima maupun mengirim pesan.",
  "inhouse_channel.save_changes": "Simpan Perubahan",
  "inhouse_guest.promote_title": "Jadikan Kontak",
  "inhouse_guest.promote_desc":
    "Tamu ini akan dijadikan kontak tetap dan muncul di daftar kontak. Pengunjung tidak akan terputus dari chat.",
  "inhouse_guest.promote_submit": "Jadikan Kontak",
  "inhouse_guest.promote_success": "Tamu berhasil dijadikan kontak",
  "inhouse_guest.promote_failed": "Gagal menjadikan tamu sebagai kontak",
  "inhouse_guest.name": "Nama",
  "inhouse_guest.name_required": "Mohon masukkan nama kontak",
  "inhouse_guest.email": "Email",
  "inhouse_guest.email_invalid": "Format email tidak valid",
  "inhouse_guest.phone": "Nomor Telepon",
  "apiKey.overview_postman_label": "Postman Collection:",
  "apiKey.download_postman": "Unduh Postman Collection",
  "appSetting.script_has_been_copied": "PHP Demo Script berhasil disalin",
  "appSetting.copy_failed": "Gagal menyalin",
  "apiKey.video_tutorial_title": "Video Tutorial",
  "apiKey.video_tutorial_integration": "Cara Integrasi API CRM",
  "whatsapp.choose_number_type_title": "Pilih Jenis Nomor",
  "whatsapp.number_type_new": "Nomor baru",
  "whatsapp.number_type_new_desc":
    "Nomor yang belum dipakai di aplikasi WhatsApp mana pun. Setelah terhubung, nomor hanya bisa dipakai lewat CRM.",
  "whatsapp.number_type_coexistence":
    "Nomor WhatsApp Business yang sudah dipakai di HP",
  "whatsapp.number_type_coexistence_desc":
    "Nomor tetap bisa dipakai di aplikasi WhatsApp Business di HP sekaligus di CRM.",
  "whatsapp.coexistence_notice_title": "Sebelum melanjutkan",
  "whatsapp.coexistence_requirement":
    "Pastikan aplikasi WhatsApp Business di HP minimal versi 2.24.17.",
  "whatsapp.coexistence_no_history":
    "Riwayat chat sebelum terhubung tidak ikut masuk ke CRM.",
  "whatsapp.coexistence_not_synced":
    "Group chat, panggilan, katalog, dan status tidak tersinkron ke CRM.",
  "whatsapp.coexistence_lost_phone_features":
    "Di HP, fitur pesan sementara, sekali lihat, live location, dan broadcast list tidak bisa dipakai lagi.",
  "users.invite_logged_in_title": "Kamu sedang login di browser ini",
  "users.invite_logged_in_description":
    "Undangan ini tidak bisa diproses selama ada akun yang sedang login. Logout terlebih dahulu untuk melanjutkan. Akun tersebut juga akan logout di tab lain.",
  "users.invite_logout_and_continue": "Logout & lanjutkan",
  "users.invite_back_to_app": "Kembali ke aplikasi",
  "inhouse_channel.section_header": "Header Widget",
  "inhouse_channel.section_header_desc":
    "Atur judul, deskripsi, dan gambar yang tampil di bagian atas widget chat.",
  "inhouse_channel.header_picture": "Gambar / Logo",
  "inhouse_channel.header_picture_help":
    "JPG, PNG, atau WEBP, maksimal {{size}}MB. Kosongkan untuk memakai logo default.",
  "inhouse_channel.header_picture_choose": "Pilih Gambar",
  "inhouse_channel.header_picture_change": "Ganti Gambar",
  "inhouse_channel.header_picture_remove": "Hapus",
  "inhouse_channel.header_picture_invalid_type":
    "Format gambar harus JPG, PNG, atau WEBP",
  "inhouse_channel.header_picture_too_large":
    "Ukuran gambar maksimal {{size}}MB",
  "inhouse_channel.header_name": "Judul",
  "inhouse_channel.header_name_help": "Kosongkan untuk memakai judul default.",
  "inhouse_channel.header_description": "Deskripsi",
  "inhouse_channel.header_description_help":
    "Tampil di bawah judul. Kosongkan untuk memakai deskripsi default.",
  "inhouse_channel.header_preview": "Pratinjau",
  "inhouse_channel.header_preview_note":
    "Perubahan berlaku saat pelanggan membuka sesi chat berikutnya.",
  "inhouse_channel.header_conflict_title": "Perubahan belum tersimpan",
  "inhouse_channel.header_conflict_desc":
    "Ada perubahan lain pada channel ini yang sedang diproses. Coba simpan lagi?",
  "inhouse_channel.header_retry": "Coba Lagi",
  "inhouse_channel.header_preview_sample_date": "Kemarin",
  "inhouse_channel.header_preview_sample_message": "Halo kak",
  "inhouse_channel.header_default_name": "Butuh bantuan?",
  "inhouse_channel.header_default_description": "Tim kami siap membantu",
  // [crm-iso] START — provider terpengaruh (lihat CrmIsoSetting/TEARDOWN.md)
  "crm_iso.affected_providers": "Provider Terpengaruh",
  "crm_iso.affected_providers_desc":
    "Agen terpengaruh hanya melihat percakapan dari nomor provider ini. Nomor yang tidak cocok dengan provider mana pun akan disembunyikan.",
  "crm_iso.add_provider": "Tambah Provider",
  "crm_iso.col_provider": "Provider",
  "crm_iso.col_prefix": "Prefix Nomor",
  "crm_iso.empty_providers": "Belum ada provider",
  "crm_iso.select_provider": "Pilih provider",
  "crm_iso.select_provider_hint":
    "Pilih satu atau beberapa provider untuk ditambahkan.",
  "crm_iso.division": "Divisi",
  "crm_iso.division_all": "Semua divisi",
  "crm_iso.division_filter_hint":
    "Opsional. Saring pilihan agen utama & agen tergabung berdasarkan divisi.",
  // [crm-iso] END
  "error_page.updating_app": "Memperbarui aplikasi...",
  "error_page.updating_app_desc":
    "Versi terbaru sedang dimuat, halaman akan dimuat ulang otomatis.",
  "error_page.update_failed": "Gagal memuat versi terbaru",
  "error_page.update_failed_desc":
    "Pembaruan otomatis sudah dicoba, tetapi belum berhasil.",
  "error_page.reload": "Muat Ulang",
  "error_page.clear_cache_title": "Hapus cache browser",
  "error_page.clear_cache_desc":
    "Versi terbaru masih gagal dimuat. Hapus cache browser dengan langkah berikut.",
  "error_page.clear_cache_step_1":
    "Tekan Ctrl + Shift + Delete (Windows) atau Cmd + Shift + Delete (Mac).",
  "error_page.clear_cache_step_2":
    'Di "Rentang waktu", pilih "Sepanjang waktu".',
  "error_page.clear_cache_step_3":
    'Centang hanya "Gambar dan file dalam cache". Hapus centang lainnya supaya Anda tidak logout.',
  "error_page.clear_cache_step_4": 'Klik "Hapus data".',
  "error_page.clear_cache_footer":
    "Setelah itu, klik {{button}}. Kalau masih gagal, hubungi tim support CRM.id.",
  "inhouse_channel.send_message": "Kirim Pesan Inhouse",
  "notification.update_description":
    "Muat ulang untuk memakai fitur dan perbaikan terbaru. Hanya butuh beberapa detik.",
  "notification.update_description_draft":
    "Selesaikan dulu pesan atau data yang sedang Anda isi. Versi baru akan dipasang otomatis saat Anda pindah halaman.",
  "notification.update_data_safe":
    "Data Anda aman, halaman ini tidak akan dimuat ulang sendiri",
  "notification.update_reload": "Muat ulang",
  "notification.update_confirm_title": "Muat ulang sekarang?",
  "notification.update_confirm_content":
    "Pesan atau data yang belum disimpan di halaman ini akan hilang.",
  "notification.update_confirm_ok": "Tetap muat ulang",
  "whatsapp.channel_section_title": "Channel WhatsApp",
  "whatsapp.channel_section_description":
    "Hubungkan nomor WhatsApp Business Anda. Chat dari pelanggan akan masuk ke inbox.",
  "whatsapp.add_card_title": "Tambah Channel",
  "whatsapp.add_card_desc": "Hubungkan nomor WhatsApp",
  "sider.channel": "Channel",
  "contact.filter_channel": "Channel",
  "contact.all_channel": "Semua channel",
  "contact.channel_whatsapp": "WhatsApp",
  "contact.channel_inhouse": "Inhouse",
  "template.no_channel_title": "Belum ada channel",
  "template.no_channel_description":
    "Template bisa dibuat untuk channel WhatsApp maupun Inhouse. Hubungkan channel terlebih dahulu untuk membuat template.",
  "template.button": "Tombol",
  "template.button_description":
    "Opsional, maksimal {{value}} tombol. Tombol tampil di bawah pesan.",
  "template.button_quick_reply": "Balasan cepat",
  "template.button_url": "Tautan",
  "template.button_text": "Teks tombol",
  "template.button_text_required": "Teks tombol wajib diisi",
  "template.button_url_required": "URL tombol tautan wajib diisi",
  "template.button_url_invalid": "URL harus diawali http:// atau https://",
  "template.button_url_hint":
    "Untuk tautan dinamis, tambahkan {{placeholder}} di URL. Isinya diisi saat template dikirim.",
  "template.button_url_placeholder_invalid":
    "Placeholder URL hanya boleh {{placeholder}} dan maksimal satu",
  "template.button_url_placeholder_single":
    "Hanya satu tombol tautan yang boleh memakai {{placeholder}}",
  "template.button_add": "Tambah tombol",
  "template.button_param": 'Parameter tombol "{{value}}"',
  "template.button_param_required": "Parameter tombol wajib diisi",
  "inhouse_contact.title": "Tersedia data dari Inhouse",
  "inhouse_contact.multiple_users":
    "Ditemukan {{count}} user, pilih salah satu:",
  "inhouse_contact.select_company": "Pilih perusahaan",
  "inhouse_contact.company": "Perusahaan",
  "inhouse_contact.apply": "Gunakan data ini",
  "inhouse_contact.applied":
    "Data inhouse diterapkan, periksa kembali sebelum menyimpan",
  "ticketing.inhouse_contact_title": "Pilih Kontak dari Channel Inhouse",
  "ticketing.inhouse_channel": "Channel Inhouse",
  "ticketing.select_inhouse_channel": "Pilih channel inhouse",
  "ticketing.inhouse_contact_tag": "Inhouse",
  "ticketing.inhouse_contact_info": "Kontak ini berasal dari channel inhouse",
  "reports.vi_detail_conversation": "Detail Conversation",
  "reports.vi_export_processing":
    "Export sedang diproses. Link unduhan akan dikirim ke halaman ini dan ke email kamu setelah selesai.",
  "reports.vi_export_processing_title": "Export sedang diproses",
  "reports.vi_export_success_title": "Export selesai",
  "reports.vi_export_failed_title": "Export gagal",
  "reports.vi_export_ready":
    "File siap diunduh. Link berlaku 1 hari dan juga sudah dikirim ke email kamu.",
  "reports.vi_export_download_here": "Download di sini",
  "reports.vi_export_download_part": "Download file {{number}}",
};

const data = {
  locale: "id-ID",
  antdData,
  messages,
};

export default data;
